(function () {
    'use strict';

    angular.module('app').controller('LoyaltiesController', LoyaltiesController);

    LoyaltiesController.$inject = [
        '$rootScope',
        '$scope',
        '$filter',
        '$routeParams',
        '$location',
        '$timeout',
        '$translate',
        '$anchorScroll',
        'blockUI',
        '$uibModal',
        'LoyaltyService',
        'TerminalService',
        'GoodsService',
        'POSService',
        'SelectService',
        'NotifyService',
        'BusinessService',
        'CouponsService',
        'LANGS',
        'SettingsService',
        'ExternalFormService',
        'ShortenerService',
        'ExportLoyaltyService',
        'CorporateCustomerService',
        'EmbeddedService'
    ];

    function LoyaltiesController(
        $rootScope,
        $scope,
        $filter,
        $routeParams,
        $location,
        $timeout,
        $translate,
        $anchorScroll,
        blockUI,
        $uibModal,
        LoyaltyService,
        TerminalService,
        GoodsService,
        POSService,
        SelectService,
        NotifyService,
        BusinessService,
        CouponsService,
        LANGS,
        SettingsService,
        ExternalFormService,
        ShortenerService,
        ExportLoyaltyService,
        CorporateCustomerService,
        EmbeddedService) {

        $scope.model = {};
        $scope.rule = {};
        $scope.loyaltiesList = [];
        $scope.separatorList = [',', ';', '\t', '\n'];
        // $scope.separatorList = [',', ';', '\n'];

        $scope.multilang = MultilanguageHelper();
        $scope.staff = {};
        $scope.referral = {};
        $scope.referrer = {};
        $scope.itemByIndex = itemByIndex;
        $scope.makeAccountsList = SelectService.makeBusinessSpecialAccountsList;
        $scope.getTimezonesList = SelectService.getTimezonesList;
        $scope.getGoodsCategoriesList = SelectService.getGoodsCategoriesList;

        $scope.getCurrenciesList = getCurrenciesList;
        $scope.currentTab = 'general';

        $scope.main = {
            image: {
                new: false,
                src: '',
                cropped: ''
            }
        }

        $scope.referral.image = {
            new: false,
            src: '',
            cropped: '',
            delete: false
        }

        $scope.referrer.image = {
            new: false,
            src: '',
            cropped: '',
            delete: false
        };

        $scope.isInCust = appConfig.platformParams.main_site.en === 'incust.com';

        $scope.colorPickerOptions = {
            inputClass: 'form-control',
            format: 'hex',
            pos: 'top left',
            swatchBootstrap: true,
            swatch: true,
            swatchPos: 'left',
            case: 'lower'
        }

        $scope.import = {
            preview: null,
            file: null,
            sections: null,
            selectedAll: true,
            unselectedAll: false,
            selectedAllToExport: true,
            unselectedAllToExport: false,
        }


        $scope.data = {
            showDisabledCategories: false,
            showCategoryRuleDisabled: false,
            default_item_price_decimal_digits: 2,
            maximum_item_price_decimal_digits: 2,
            loyaltyLinks: [
                {type: 'web', title: 'Web site', icon: 'fa-home'},
                {type: 'email', title: 'Email', icon: 'fa-envelope'},
                {type: 'facebook', title: 'Facebook', icon: 'fa-facebook-official'},
                {type: 'youtube', title: 'Youtube', icon: 'fa-youtube'},
                {type: 'twitter', title: 'Twitter', icon: 'fa-twitter-square'},
                {type: 'tiktok', title: 'TikTok', icon: 'fa-tiktok'},
                {type: 'linkedin', title: 'LinkeIn', icon: 'fa-linkedin'},
                {type: 'telegram', title: 'Telegram', icon: 'fa-telegram'},
                {type: 'instagram', title: 'Instagram', icon: 'fa-instagram'},
                {type: 'pinterest', title: 'Pinterest', icon: 'fa-pinterest'},
                {type: 'vk', title: 'VK', icon: 'fa-vk'}
            ],
            action_types: [
                {id: 'discount-percent-by-item', title: 'Discount on goods, %'},
                {id: 'discount-amount-by-item', title: 'Discount on goods, amount'},
                {id: 'special-price-by-item', title: 'Special price for goods'},
                {id: 'discount-percent-by-check', title: 'Discount on cash receipt, %'},
                {id: 'discount-amount-by-check', title: 'Discount on cash receipt, amount'},
                {id: 'charge-percent-by-item', title: 'Credit on goods, %'},
                {id: 'charge-amount-by-item', title: 'Credit on goods, amount'},
                {id: 'charge-percent-by-check', title: 'Credit on cash receipt, %'},
                {id: 'charge-amount-by-check', title: 'Credit on cash receipt, amount'},
                {id: 'emission-coupon-by-item', title: 'TEXT_RULE_EMISSION_COUPON_BY_ITEM'},
                {id: 'emission-coupon-by-check', title: 'TEXT_RULE_EMISSION_COUPON_BY_CHECK'}
            ],
            action_types_corporate: [
                {id: 'discount-percent-by-item', title: 'Discount on goods, %'},
                {id: 'discount-amount-by-item', title: 'Discount on goods, amount'},
                {id: 'special-price-by-item', title: 'Special price for goods'},
                {id: 'discount-percent-by-check', title: 'Discount on cash receipt, %'},
                {id: 'discount-amount-by-check', title: 'Discount on cash receipt, amount'},
            ],
            sales_types: [
                {id: 'all', title: 'All sales'},
                {id: 'first-only', title: 'Only first sale'},
                {id: 'all-but-first', title: 'Second and next sales'}
            ],
            customer_types: [
                {id: 'identified', title: 'TEXT_IDENTIFIED'},
                {id: 'anonymous', title: 'TEXT_ANONYMOUS'},
                {id: 'all', title: 'All sales'}
            ],
            rule_depends: [
                {id: 'amount', title: 'Amount'},
                {id: 'quantity', title: 'Quantity'},
                /*                {id: 'bonuses-earned', title: 'bonuses-earned'},
                                {id: 'bonuses-on-account', title: 'bonuses-on-account'},*/
                {id: 'none', title: 'No dependence'}
            ],
            rule_period: [
                {id: 'all', title: 'For all time'},
                {id: 'check', title: 'For cash receipt'},
                {id: 'day', title: 'For day'},
                {id: 'week', title: 'For week'},
                {id: 'month', title: 'For months'},
                {id: 'three-month', title: 'For three months'},
                {id: 'year', title: 'For year'},
                {id: 'current-week', title: 'For this week (since Monday)'},
                {id: 'past-week', title: 'For last week (since Monday)'},
                {id: 'current-month', title: 'For current month (from the 1st)'},
                {id: 'past-month', title: 'For last month (from the 1st of the last month)'},
                {id: 'current-quarter', title: 'For current quarter'},
                {id: 'past-quarter', title: 'For last quarter'},
                {id: 'current-year', title: 'For current year (since January 1st)'},
                {id: 'past-year', title: 'For last year (since January 1st of the last year)'}
            ],
            show_customers_questionnaire_options: [
                {id: 'do-not-show', title: 'Do not display'},
                {id: 'show-only-for-new', title: 'Display only for new customers'},
                {id: 'show-for-all', title: 'Display for all customers'}
            ],
            notification_types: [
                {id: 'none', title: 'TEXT_NO_NOTIFICATION'},
                {id: 'push-chatbot-sms', title: 'TEXT_PUSH_CHATBOT_VIBER_SMS'},
                {id: 'push-chatbot-viber', title: 'TEXT_PUSH_CHATBOT_VIBER'},
                {id: 'push-chatbot', title: 'TEXT_PUSH_CHATBOT'},
                {id: 'viber-sms', title: 'TEXT_VIBER_SMS'},
                {id: 'push', title: 'TEXT_PUSH'},
                {id: 'chatbot', title: 'TEXT_CHATBOT'},
                // {id: 'viber', title: 'TEXT_VIBER'},
                {id: 'sms', title: 'TEXT_SMS'},
                {id: 'email', title: 'TEXT_EMAIL'}
            ],
            category_notification_types: [
                {id: 'none', title: 'TEXT_NO_NOTIFICATION'},
                {id: 'push-chatbot-sms', title: 'TEXT_PUSH_CHATBOT_VIBER_SMS'},
                {id: 'push-chatbot-viber', title: 'TEXT_PUSH_CHATBOT_VIBER'},
                {id: 'push-chatbot', title: 'TEXT_PUSH_CHATBOT'},
                {id: 'viber-sms', title: 'TEXT_VIBER_SMS'},
                {id: 'push', title: 'TEXT_PUSH'},
                {id: 'chatbot', title: 'TEXT_CHATBOT'},
                // {id: 'viber', title: 'TEXT_VIBER'},
                {id: 'sms', title: 'TEXT_SMS'},
                {id: 'email', title: 'TEXT_EMAIL'}
            ],
            new_customer_access_types: [
                {id: 'full-bonuses-access', title: 'Full access: crediting and redemption of bonus points'},
                {id: 'add-bonuses-only', title: 'Limited access: only crediting of bonus points'},
                {
                    id: 'waiting-for-confirmation',
                    title: 'No access: awaiting processing of personal data. Crediting and redemption of bonus points are forbidden'
                }
            ],
            bonus_payment_types: [
                {id: 'partial', title: 'Partial payment of receipt is possible'},
                {
                    id: 'partial-rounded',
                    title: 'Partial payment of receipt which is rounded to the nearest integer is possible'
                },
                {id: 'full-check', title: 'Only full payment of receipt is possible'}
            ],
            birthdate_gifts: [
                {id: 'bonuses', title: 'TEXT_BIRTHDAY_GIFT_BONUS_POINTS'},
                {id: 'promotional-bonuses', title: 'TEXT_BIRTHDAY_GIFT_SPECIAL_BONUS_POINTS'},
                {id: 'coupon', title: 'TEXT_BIRTHDAY_GIFT_COUPON'},
                {id: 'none', title: 'TEXT_BIRTHDAY_GIFT_NONE'}
            ],
            week_days: [
                {id: 'monday', title: 'Monday'},
                {id: 'tuesday', title: 'Tuesday'},
                {id: 'wednesday', title: 'Wednesday'},
                {id: 'thursday', title: 'Thursday'},
                {id: 'friday', title: 'Friday'},
                {id: 'saturday', title: 'Saturday'},
                {id: 'sunday', title: 'Sunday'}
            ],
            delivery_services_type: [
                'amount',
                'percentage',
                'multiplier'
            ],
            rules_calc_schemes: [
                {id: 'summarizing', title: 'rules#settings#rules_calc_schemes#summarizing'},
                {id: 'maximum', title: 'rules#settings#rules_calc_schemes#maximum'},
                {id: 'sequential', title: 'rules#settings#rules_calc_schemes#sequential'},
            ],
            applicable_api_scope_list: [
                {id: 'all', title: 'rules#edit#applicable_api_scope#all'},
                {id: 'client', title: 'rules#edit#applicable_api_scope#client'},
                {id: 'terminal', title: 'rules#edit#applicable_api_scope#terminal'},
            ],
            corporateCustomerCategories: [],
        };

        $scope.state = {
            dontUseBonuses: false
            // rulesOrderChanged: false,
            // rulesCategoryOrderChanged: false
        };

        $scope.errors = {};

        $scope.additional = {};
        $scope.card_categories_settings = {};
        //  $scope.card_categories_rules = {};
        $scope.referral_program = {};
        $scope.online_store = {};
        $scope.pkpass = {}
        $scope.pkpassDefault = {
            background_color: true,
            foreground_color: true,
            label_color: true
        }
        $scope.POSPkpass = {
            selectedPos: null,
            cardTypes: [
                {
                    type: 'digital',
                    title: 'pos#pkpass#add_card_type_digital'
                },
                {
                    type: 'plastic',
                    title: 'pos#pkpass#add_card_type_plastic'
                }
            ],
            cardType: {
                type: 'digital',
                title: 'pos#pkpass#add_card_type_digital'
            },
            qrCodeLink: '',
            link: ''
        }
        $scope.delivery_types = [];
        $scope.delivery = {};
        $scope.delivery_multilang = MultilanguageHelper();

        $scope.message = {};
        $scope.test = {};

        $scope.service_list = [];
        $scope.service_list_has_delivery = false;
        $scope.delivery_service = {};
        $scope.delivery_service_multilang = MultilanguageHelper();

        $scope.external_forms_rules = [];
        $scope.external_access = [];
        $scope.show_disabled_external_forms_rules = false;

        $scope.to_export_sections = ExportLoyaltyService.toExportSectionsDefault;

        $scope.rule_settings = {};
        $scope.current_rule_settings = {};

        $scope.initLocaleStrings = initLocaleStrings;
        $scope.onNewLoyaltyClick = onNewLoyaltyClick;
        $scope.isRouteMode = isRouteMode;
        $scope.isPageMode = isPageMode;
        $scope.getDeliveryServicesById = getDeliveryServicesById;
        $scope.removeDeliveryServicesById = removeDeliveryServicesById;

        var block_loyalties_list = blockUI.instances.get('loyalties_list'),
            block_edit = blockUI.instances.get('edit_loyalty'),
            block_external_access = blockUI.instances.get('block_external_access'),
            block_export_import = blockUI.instances.get('block_export_import');

        var previousRule;

        $scope.isURLValid = isURLValid;
        $scope.platformSupportedLanguagesCodes = Object.keys(LANGS) || [];
        SettingsService.GetPlatformSupportedLanguages(function (success, response) {
            $scope.platformSupportedLanguagesCodes = response;
        });
        initController();

        // *********************************************************************************************
        //  MAIN PART
        // *********************************************************************************************

        /**
         * Page mode display differed parts. Now 'show', 'create', 'edit'.
         * Use as <ANY ng-if="isPageMode('show')">
         */
        function isPageMode(mode) {
            return mode === $scope._pageMode;
        }

        /**
         * Check parameter 'mode' in route ../loyalty/{mode}
         */
        function isRouteMode(mode) {
            return $routeParams && $routeParams.hasOwnProperty('mode') && $routeParams.mode === mode;
        }

        /**
         * Initialize page mode by url
         */
        function initPageMode() {
            $scope._pageMode = 'show';
            if (isRouteMode('edit')) {
                if ($routeParams['tab'] && $routeParams['tab'] != 'general')
                    $scope.currentTab = $routeParams['tab'];
                $scope._pageMode = ($routeParams.hasOwnProperty('loyalty_id')) ? 'edit' : 'show';
            } else if (isRouteMode('create')) $scope._pageMode = 'create';
        }

        /**
         * Initialize controller
         */
        function initController() {

            if ($scope.isInCust) {
                $scope.data.notification_types.push({id: 'chatbot', title: 'TEXT_CHATBOT_7LOC'});
                $scope.data.category_notification_types.push({id: 'chatbot', title: 'TEXT_CHATBOT_7LOC'});
            }

            loadExternalAccessScope();
            SettingsService.GetPlatformParams(function (success, response) {
                if (success) {
                    if (typeof response.default_item_price_decimal_digits === 'number') {
                        $scope.data.default_item_price_decimal_digits = response.default_item_price_decimal_digits;
                    }
                    if (typeof response.maximum_item_price_decimal_digits === 'number') {
                        $scope.data.maximum_item_price_decimal_digits = response.maximum_item_price_decimal_digits;
                    }

                    if (!!response.allow_messages_to_external_system) {
                        $scope.data.notification_types.push({
                            id: 'external-system', title: 'TEXT_EXTERNAL_SYSTEM'
                        });
                        $scope.data.category_notification_types.push({
                            id: 'external-system', title: 'TEXT_EXTERNAL_SYSTEM'
                        });
                    }
                }
            });

            $scope.multilang.initLangs(LANGS, $rootScope.LANG);
            $scope.delivery_multilang.initLangs(LANGS, $rootScope.LANG);
            $scope.delivery_service_multilang.initLangs(LANGS, $rootScope.LANG);

            initPageMode();

            switch ($scope._pageMode) {
                case 'create':
                    doCreate();
                    break;
                case 'show':
                    doShow();
                    break;
                case 'edit':
                    doEdit();
                    break;
            }
        }

        /**
         * Main tabs changes. Need for initialize data specifics by tab
         */
        $scope.onChangeTab = function (tab) {
            console.info('TAB', tab);

            var form = angular.element('#form').scope().form;
            console.info('FORM', form);
            $scope.model.isRuleEdit = false;
            $scope.model.isDeliveryEdit = false;
            $scope.model.isDeliveryServicesEdit = false;

            if ($scope.currentTab == 'general' && tab != 'general' && (form.$dirty || $scope.main.image.new || isPageMode('create'))) {
                var modalInstance = $uibModal.open({
                    animation: true,
                    keyboard: true,
                    size: 'sm',
                    templateUrl: 'app/templates/modal.confirmation.html',
                    controllerAs: 'popup',
                    controller: function ($uibModalInstance) {
                        var popup = this;

                        popup.type = 'loyalty';

                        popup.onSaveClick = function (exit) {
                            if (form.$valid && form.$dirty) {
                                $scope.saveLoyaltyChanges(form, false, true);
                                $scope.currentTab = tab;
                                $location.url($location.$$path + '?tab=' + tab);
                                onSwitchTab(tab);
                            } else {
                                form.$dirty = true;
                                form.title.$dirty = form.public_title.$dirty
                                    = form.public_description.$dirty
                                    = true;
                            }
                            $uibModalInstance.close();
                        };

                        popup.onCancelClick = function (exit) {
                            if (isPageMode('create'))
                                $scope.currentTab = 'general';
                            else {
                                $scope.currentTab = tab;
                                $location.url($location.$$path + '?tab=' + tab);
                                onSwitchTab(tab);
                            }
                            $uibModalInstance.close();
                        };
                    }
                });
            } else {
                $scope.currentTab = tab;
                $location.url($location.$$path + '?tab=' + tab);
            }
        };

        function onSwitchTab(tab) {

            function s() {
                if ($rootScope.ENV.business.tariff) {
                    if ($rootScope.ENV.business.tariff.active_customer_categories_number &&
                        $rootScope.ENV.business.tariff.active_customer_categories_number > 0)
                        $rootScope.TARIFF_LIMITATION.active_customer_categories_number = $rootScope.ENV.business.tariff.active_customer_categories_number;
                    else
                        $rootScope.TARIFF_LIMITATION.active_customer_categories_number = 0;

                    if ($rootScope.ENV.business.tariff.active_loyalty_rules_number &&
                        $rootScope.ENV.business.tariff.active_loyalty_rules_number > 0)
                        $rootScope.TARIFF_LIMITATION.active_loyalty_rules_number = $rootScope.ENV.business.tariff.active_loyalty_rules_number;
                    else
                        $rootScope.TARIFF_LIMITATION.active_loyalty_rules_number = 0;
                } else {
                    $timeout(s, 250);
                }
            }

            s();

            switch (tab) {
                case 'general':
                case 'cards':
                    getLoyaltyCardCategories(function (success, response) {
                        if (success) {
                            $scope.data.cardCategories = angular.copy(response);
                        }
                    });
                    break;
                case 'rules':
                    getLoyaltyRules();
                    break;
                case 'additional':
                    getAdditionalSettings();
                    break;
                case 'referral_program':
                    getReferralProgram();
                    break;
                case 'online_store':
                    getOnlineStore();
                    break;
                case 'pkpass':
                    getPkpassSettings();
                    break;
                case 'messages':
                    getMessageInfo();
                    break;
                case 'cards_settings':
                    getCardCategoriesSettings();
                    break;
                case 'taxes':
                    getTaxes();
                    break;
                case 'additional_costs':
                    getAdditionalCosts();
                    break;
                case 'external_forms':
                    getExternalFormsRules(function () {
                    });
                    break;
                case 'external_access':
                    loadExternalAccessInfo();
                    break;
            }
        }

        // *********************************************************************************************
        //  SHOW PART
        // *********************************************************************************************

        /**
         * Prepare data for display page in mode  'show'
         */
        function doShow() {
            block_loyalties_list.start();

            LoyaltyService.All(function (success, data) {
                if (success) {
                    $scope.loyaltiesList = angular.copy(data);
                    POSService.All({}, function (success, data) {
                    });
                }
                block_loyalties_list.stop();
            });

        }

        /**
         * Loyalties enable/disable click
         */
        $scope.onLoyaltyToggleClick
            = function (loyalty) {
            //$scope.loyaltyState.loading();
            var post_data = {
                id: loyalty.id,
                active: 1 * !Boolean(loyalty.active)
            };
            block_loyalties_list.start();
            LoyaltyService.Change(loyalty.id, post_data, function (success, data) {
                block_loyalties_list.stop();
                //$scope.loyaltyState.loaded();
            });
        };

        /**
         * Links realtime validation
         */
        $scope.validation = function (link) {
            if (!link.url) link.error = $translate.instant('LINK_VALIDATION_ERROR');
            else link.error = '';
        };

        $scope.changeBonusPaymentLimit = function () {

            $scope.state.dontUseBonuses = (parseInt($scope.additional.bonus_payment_limit) == 0) ||
                ($scope.additional.bonus_payment_limit === null);

            if (parseInt($scope.additional.bonus_payment_limit) > 100) {
                $scope.additional.bonus_payment_limit = 100;
            }
        };

        $scope.onChangeDontUseBonuses = function () {
            if ($scope.state.dontUseBonuses) {
                $scope.additional.bonus_payment_limit = 0;
            } else {
                $scope.additional.bonus_payment_limit = 100;
            }
        };
        $scope.onChangeBonusPaymentType = function () {
            console.log('onChangeBonusPaymentType', $scope.additional.bonus_payment_type);

            switch ($scope.additional.bonus_payment_type) {
                case 'partial':

                    break;
                case 'partial-rounded':

                    break;
                case 'full-check':
                    $scope.state.dontUseBonuses = false;
                    $scope.additional.bonus_payment_limit = 100;
                    break;
            }
        };

        function getLoyaltyCategories(callback) {
            LoyaltyService.LoyaltyCategories(function (success, data) {
                if (success)
                    $scope.loyalty_categories = $rootScope.LOYALTY_CATEGORIES[$rootScope.LANG];

                callback(true);
            });
        }

        // *********************************************************************************************
        //  CREATE & EDIT PART
        // *********************************************************************************************

        /**
         * Event receive when change editing language
         */
        $scope.onChangeLanguage = function (new_lang) {
            $scope.multilang.selected(new_lang);
            $scope.delivery_multilang.selected(new_lang);
            $scope.delivery_service_multilang.selected(new_lang);
            if ($scope.data.action_types && $scope.rule.action_type) {
                $scope.staff.boonTitle = $filter('translate')(itemByIndex($scope.data.action_types, $scope.rule.action_type).title);
            }
        };

        /**
         * Init loyalty string
         */
        function initLocaleStrings(loyalty) {
            $scope.multilang.initStrings(loyalty, ['public_title', 'public_description', 'legal_info', 'privacy_policy_url']);
        }

        /**
         * Prepare data for display page in mode 'create'
         */
        function doCreate() {
            getLoyaltyCategories(function (success) {
            });

            $scope.model = {
                id: '',
                // rate: 10,
                // rate_type: "bonus",
                categories: [],
                active: 1
            };

            $scope.initLocaleStrings($scope.model);
        }

        /**
         * Prepare data for display page in mode 'edit'
         */
        function doEdit() {
            block_edit.start();

            $scope.loyaltyId = $routeParams.loyalty_id;
            LoyaltyService.Get($routeParams.loyalty_id, function (success, data) {
                if (success) {
                    $scope.model = angular.copy(data);

                    if (!$scope.model.categories)
                        $scope.model.categories = [];

                    getCurrenciesList();
                    getCouponBatchesList();
                    getAccountsList();
                    getDeliveryServices();

                    getLoyaltyCategories(function (success) {
                        for (var i in $scope.loyalty_categories)
                            for (var k in $scope.model.categories)
                                if ($scope.model.categories[k].id == $scope.loyalty_categories[i].id)
                                    $scope.model.categories[k] = $scope.loyalty_categories[i];
                    });

                    if ($routeParams['tab'] && $routeParams['tab'] !== 'general') {
                        onSwitchTab($routeParams['tab']);
                    } else {
                        for (var i in $scope.model.links) {
                            for (var k in $scope.data.loyaltyLinks) {
                                if (i === $scope.data.loyaltyLinks[k].type) {
                                    $scope.data.loyaltyLinks[k].url = $scope.model.links[i];
                                    $scope.data.loyaltyLinks[k].used = true;
                                }
                            }
                        }

                        $scope.initLocaleStrings($scope.model);
                        // try {
                        //     //$scope.links_edit = JSON.parse($scope.model.links);
                        //     angular.forEach(Object.keys($scope.model.links), function(key){
                        //         $scope.linksTypesApplied[key] = $scope.linksTypes[key];
                        //         delete $scope.linksTypes[key];
                        //     });
                        // } catch (e) {
                        //     console.warn('model.links', $scope.model.links);
                        // }
                        // $scope.initLocaleStrings($scope.model);
                    }
                    //$scope.loyaltyState.loaded();
                } else {
                    $location.path('/loyalties');
                    // $scope.loyaltyState.loaded();
                }
                block_edit.stop();
            });
        }

        function getLoyaltyCardCategories(callback) {
            block_edit.start();

            LoyaltyService.CardCategories($routeParams.loyalty_id, function (success, data) {
                callback(success, data);
                block_edit.stop();
            });

        }

        $scope.onChangeCouponRulesUsageType = function () {
            block_edit.start();

            LoyaltyService.UpdateLoyaltyRulesSettings($routeParams.loyalty_id, $scope.rule_settings, function (success, data) {
                if (success) {
                    $scope.rule_settings = JSON.parse(JSON.stringify(data));
                    $scope.current_rule_settings = JSON.parse(JSON.stringify(data));
                }
                block_edit.stop();
            });
        };

        $scope.equalObjects = function (obj1, obj2) {
            return JSON.stringify(obj1) === JSON.stringify(obj2)
        }

        function getLoyaltyRules() {
            var id = $routeParams.loyalty_id;

            block_edit.start();

            $scope.rule_settings = {
                count_bonuses_redeemed_amount_for_charge: 0,
                count_bonuses_redeemed_amount_for_discount: 0,
                coupon_rules_usage_type: "in-cooperation",
                only_one_coupon_rule_per_check: 0,
                rules_calc_scheme: "summarizing"
            }

            LoyaltyService.LoyaltyRules(id, function (success, data) {
                if (success) {
                    var rules = [];
                    data.forEach(function (el, i) {
                        if (el.automatic == 2) {
                            rules.push(el);
                            delete data[i];
                        }
                    });
                    data = $filter('orderBy')(data, 'priority');
                    data.forEach(function (el) {
                        rules.push(el);
                    });

                    $scope.data.loyaltyRules = rules;
                    $scope.model.isRuleEdit = false;
                }
                LoyaltyService.GetLoyaltyRulesSettings(id, function (success, data) {
                    if (success) {
                        $scope.rule_settings = JSON.parse(JSON.stringify(data));
                        $scope.current_rule_settings = JSON.parse(JSON.stringify(data));
                        $scope.data.coupon_rules_usage_type = data.coupon_rules_usage_type || null;
                    }
                    block_edit.stop();
                });

            });
        }

        /**
         * Raised when user select local file
         * @param evt
         */
        $scope.handleFileSelect = function (evt) {
            var file = evt.currentTarget.files[0],
                reader = new FileReader();

            var imageType = file.type,
                isPng = imageType === 'image/png';

            reader.onload = function (e) {
                var img = new Image();
                img.onload = function () {
                    var canvas = document.getElementById('file-canvas'),
                        ctx = canvas.getContext('2d'),
                        width = img.width,
                        height = img.height,
                        maxAllowedSize = 2 * 1024 * 1024;

                    canvas.width = width;
                    canvas.height = height;
                    ctx.clearRect(0, 0, width, height);
                    ctx.drawImage(img, 0, 0, width, height);

                    var resizedImageDataUrl;

                    if (isPng) {
                        resizedImageDataUrl = canvas.toDataURL('image/png');
                    } else {
                        resizedImageDataUrl = canvas.toDataURL('image/jpeg', 1);
                    }

                    if (resizedImageDataUrl.length > maxAllowedSize) {
                        var scale = 0.95,
                            quality = 1;

                        do {
                            width = Math.round(img.width * scale);
                            height = Math.round(img.height * scale);

                            canvas.width = width;
                            canvas.height = height;
                            ctx.clearRect(0, 0, width, height);
                            ctx.drawImage(img, 0, 0, width, height);

                            if (isPng) {
                                resizedImageDataUrl = canvas.toDataURL('image/png');
                            } else {
                                quality = Math.max(quality - 0.05, 0.1);
                                resizedImageDataUrl = canvas.toDataURL('image/jpeg', quality);
                            }

                            scale -= 0.05;
                        } while (
                            resizedImageDataUrl.length > maxAllowedSize &&
                            width > 50 && height > 50
                            );
                    }

                    $scope.$apply(function () {
                        $scope.main.image.new = true;
                        $scope.main.image.src = resizedImageDataUrl;
                        $scope.main.image.cropped = '';
                        $scope.main.image.delete = false;
                        $scope.main.image.imageDataLoading = false;
                    });
                };
                img.src = e.target.result;
            };

            reader.readAsDataURL(file);
            $scope.main.image.imageDataLoading = true;
        };
        //angular.element('#loyaltyPicture').on('change', $scope.handleFileSelect);

        $scope.initImgCrop = function () {
            var file = angular.element(document.getElementById('loyaltyPicture'));
            file.on('change', $scope.handleFileSelect);
        };

        $scope.onApplicableForCustomerChange = function () {
            if ($scope.rule.applicable_for_customer === 'anonymous')
                $scope.rule.card_category_id = '0';
        };

        $scope.isCorrectRule = function (field) {
            switch (field) {
                case 'applicable_for_customer':
                    return ($scope.rule.action_type.indexOf('charge-') === -1) ? true : false;
                    break;
            }

            return false;
        };

        $scope.deleteLoyaltyPhoto = function () {
            if ($scope.main.image.new) {
                $scope.main.image.new = false;
                $scope.main.image.src = '';
                $scope.main.image.cropped = '';
            } else if ($scope.model.photos && $scope.model.photos.length > 0) {
                delete $scope.model.photos;
                $scope.main.image.delete = true;
            }
        };

        $scope.cropLoyaltyPhoto = function () {
            $uibModal.open({
                animation: false,
                keyboard: true,
                backdrop: 'static',
                templateUrl: 'app/templates/modal.crop-image.html',
                controllerAs: 'popup',
                windowTopClass: 'modal-full',
                controller: function ($uibModalInstance) {
                    var popup_crop = this;
                    popup_crop.image = angular.copy($scope.main.image);

                    popup_crop.onCancelClick = function () {
                        $uibModalInstance.close();
                    }

                    popup_crop.onCropImage = function () {
                        $scope.main.image = angular.copy(popup_crop.image);
                        $uibModalInstance.close();
                    }
                }
            })
        };
        /**
         * Saving created loyalty program
         */
        $scope.saveLoyaltyChanges = function (form, needClose, isTabSwitch) {
            console.log('saveLoyaltyChanges', form, needClose, isTabSwitch);
            block_edit.start();

            function receiveResult(success, data) {
                if (success) {
                    if ($scope.main.image.delete && !$scope.main.image.new) {
                        LoyaltyService.DeletePhoto(data.id, function (success, data) {
                            if (success) {
                                delete $scope.model.photos;
                                delete data.photos;
                                $scope.main.image.delete = false;
                                if (needClose) $location.path('/loyalties');
                            }
                        });
                    } else if ($scope.main.image.new) {
                        var image = $scope.main.image.cropped || $scope.main.image.src;
                        LoyaltyService.UploadPhoto(data.id, image, function (success, img_data) {
                            if (success) {
                                if (data.photos && data.photos[0])
                                    data.photos[0] = img_data;
                                else
                                    data.photos = [{'id': img_data.id, 'url': img_data.url}];

                                $scope.model.photos = data.photos;
                                $scope.main.image.new = false;
                                $scope.main.image.src = '';
                                $scope.main.image.delete = false;
                                if (needClose) $location.path('/loyalties');
                            }
                        });
                    } else {
                        if (needClose) $location.path('/loyalties');
                    }

                    updateItemInList($rootScope.LOYALTIES, data);
                    if (isPageMode('create') && isTabSwitch)
                        $location.path('/loyalties/edit/' + data.id);
                }
                block_edit.stop();
            }

            var post_data = angular.copy($scope.model);

            post_data.links = {};
            for (var i in $scope.data.loyaltyLinks) {
                var l = $scope.data.loyaltyLinks[i];

                if (l.used)
                    post_data.links[l.type] = l.url;
            }

            for (var i in post_data.categories) {
                delete post_data.categories[i].title;
                delete post_data.categories[i].image_url;
            }

            if (form.title.$valid && form.public_title.$valid && form.public_description.$valid) {
                if ($scope.isPageMode('create'))
                    LoyaltyService.Create(post_data, receiveResult);
                else
                    LoyaltyService.Change($scope.model.id, post_data, receiveResult);
            } else {
                form.title.$dirty = form.public_title.$dirty
                    = form.public_description.$dirty
                    = true;
                block_edit.stop();
            }
        };

        /**
         * Create new loyalty click
         */
        function onNewLoyaltyClick() {
            $location.path('/loyalties/create');
        }

        /**
         * Cancel editing
         */
        $scope.onCancelEdit = function () {
            $location.path('/loyalties');
        };

        $scope.getUnusedLinks = function () {
            var r = [],
                l = $scope.data.loyaltyLinks;

            for (var i in l)
                if (!l[i].used)
                    r.push(l[i]);

            return r;
        };

        $scope.onAddLink = function (link) {
            var l = $scope.data.loyaltyLinks;

            for (var i in l)
                if (l[i].type === link.type)
                    l[i].used = true;
        };

        $scope.onRemoveLink = function (link) {
            var l = $scope.data.loyaltyLinks;

            for (var i in l)
                if (l[i].type === link.type)
                    l[i].used = false;
        };

        // *********************************************************************************************
        //  CREATE & EDIT LOYALTY CATEGORIES
        // *********************************************************************************************

        $scope.onCategoryToggleClick = function (c) {
            var cc = itemByIndex($scope.data.cardCategories, c.id);
            cc.active = cc.active === 1 ? cc.active = 0 : cc.active = 1;
            LoyaltyService.SaveCardCategories($routeParams.loyalty_id, c.id, {
                active: cc.active
            }, function (success, data) {
                if (success) {
                    NotifyService.Success(data.message, false);
                    c = data;
                    getLoyaltyCardCategories(function (success, response) {
                        if (success) {
                            $scope.data.cardCategories = angular.copy(response);
                        }
                    });
                }
            });
        };

        $scope.getActiveCategories = function () {
            var a = 0;

            if ($scope.data.cardCategories)
                for (var i in $scope.data.cardCategories)
                    if ($scope.data.cardCategories[i].active === 1)
                        a++;
            if (a > 0)
                return a;
            else
                return 1;
        };
        $scope.deleteAdditionalCost = function (tax) {
            LoyaltyService.DeleteTax($routeParams.loyalty_id, tax.id, function () {
                getAdditionalCosts();
            });
        };

        $scope.openModalAddAdditionalCost = function (additional_cost) {
            $uibModal.open({
                animation: true,
                keyboard: true,
                backdrop: 'static',
                templateUrl: 'app/pages/loyalty/modals/modal.add-additional-costs.html',
                controllerAs: 'popup',
                windowTopClass: 'modal-center',
                controller: function ($uibModalInstance) {

                    var popup = this;

                    popup.types = [
                        {id: 'amount', title: 'Additional cost type amount'},
                        {id: 'percentage', title: 'Additional cost type percentage'}
                    ];

                    popup.additional_cost = additional_cost ? angular.copy(additional_cost) : {
                        title: '',
                        type: 'amount',
                        decimal_digits: 2,
                        default_value: 0
                    };

                    popup.corruptedFields = [];

                    popup.additionalCostValidator = {
                        isTitleValid: function (formData) {
                            var form = formData || popup.additional_cost;
                            return !!form && form.title.length;
                        },
                        isDecimalDigitsValid: function (formData) {
                            var form = formData || popup.tax;
                            return !!form && form.decimal_digits <= $scope.data.maximum_item_price_decimal_digits;
                        }
                    };

                    function validateAdditionalCost() {
                        var validationResult = {
                            isValid: true,
                            corruptedFields: []
                        };

                        for (var validatorName in popup.additionalCostValidator) {
                            var isValid = popup.additionalCostValidator[validatorName](popup.additional_cost);
                            if (!isValid) {
                                validationResult.corruptedFields.push(validatorName);
                                validationResult.isValid = false;
                            }
                        }

                        return validationResult;
                    }

                    popup.saveAdditionalCost = function () {
                        var validationResult = validateAdditionalCost();

                        popup.corruptedFields = validationResult.corruptedFields;
                        if (!validationResult.isValid) {
                            return;
                        }
                        var additional_cost = angular.copy(popup.additional_cost);
                        additional_cost.decimal_digits = parseInt(additional_cost.decimal_digits.toString());
                        additional_cost.default_value = parseFloat(additional_cost.default_value.toString());

                        if (!!additional_cost.id) {
                            LoyaltyService.EditAdditionalCosts($routeParams.loyalty_id, additional_cost.id, additional_cost, function (success, data) {
                                if (success) {
                                    popup.tax = data;
                                    getAdditionalCosts(function (success) {
                                        if (success) {
                                            popup.closeModal();
                                        }
                                    });
                                }
                            });
                        } else {
                            LoyaltyService.AddAdditionalCosts($routeParams.loyalty_id, additional_cost, function (success, data) {
                                if (success) {
                                    popup.additional_cost = data;
                                    getAdditionalCosts(function (success) {
                                        if (success) {
                                            popup.closeModal();
                                        }
                                    });
                                }

                            });
                        }

                    };
                    popup.closeModal = function (exit) {
                        $uibModalInstance.close();
                    };

                }
            });
        };

        $scope.deleteAdditionalCost = function (additional_cost) {
            LoyaltyService.DeleteAdditionalCosts($routeParams.loyalty_id, additional_cost.id, function () {
                getAdditionalCosts();
            });
        };
        $scope.deleteTax = function (tax) {
            LoyaltyService.DeleteTax($routeParams.loyalty_id, tax.id, function () {
                getTaxes();
            });
        };

        $scope.openModalAddTax = function (tax) {
            $uibModal.open({
                animation: true,
                keyboard: true,
                backdrop: 'static',
                templateUrl: 'app/pages/loyalty/modals/modal.add-tax.html',
                controllerAs: 'popup',
                windowTopClass: 'modal-center',
                controller: function ($uibModalInstance) {

                    var popup = this;
                    popup.maximum_item_price_decimal_digits = $scope.data.maximum_item_price_decimal_digits;
                    popup.classifications = [
                        {id: 'base-tax', title: 'Tax classification#base-tax'},
                        {id: 'sales-tax', title: 'Tax classification#sales-tax'}
                    ];
                    popup.types = [
                        {id: 'amount', title: 'Tax type amount'},
                        {id: 'percentage', title: 'Tax type percentage'}
                    ];
                    var previousTaxType;
                    popup.onChangeClassifications = function () {
                        if (popup.tax.classification === 'sales-tax') {
                            previousTaxType = popup.tax.type;
                            popup.tax.type = 'percentage';
                        } else if (previousTaxType) {
                            popup.tax.type = previousTaxType;
                        }
                        console.log('onChangeClassifications', popup.tax.classification);
                    };

                    popup.tax = tax ? angular.copy(tax) : {
                        title: '',
                        type: 'amount',
                        decimal_digits: $scope.data.default_item_price_decimal_digits,
                        default_value: ''
                    };
                    popup.corruptedFields = [];

                    popup.taxValidator = {
                        isTitleValid: function (formData) {
                            var form = formData || popup.tax;
                            return !!form && form.title.length;
                        },
                        isDecimalDigitsValid: function (formData) {
                            var form = formData || popup.tax;
                            return !!form && form.decimal_digits <= $scope.data.maximum_item_price_decimal_digits;
                        }
                    };

                    function validateTax() {
                        var validationResult = {
                            isValid: true,
                            corruptedFields: []
                        };

                        for (var validatorName in popup.taxValidator) {
                            var isValid = popup.taxValidator[validatorName](popup.tax);
                            if (!isValid) {
                                validationResult.corruptedFields.push(validatorName);
                                validationResult.isValid = false;
                            }
                        }

                        return validationResult;
                    }

                    popup.saveTax = function () {
                        var validationResult = validateTax();

                        popup.corruptedFields = validationResult.corruptedFields;
                        if (!validationResult.isValid) {
                            return;
                        }
                        var tax = angular.copy(popup.tax);
                        tax.decimal_digits = parseInt(tax.decimal_digits.toString());
                        tax.default_value = parseFloat(tax.default_value.toString());

                        if (!!tax.id) {
                            LoyaltyService.EditTax($routeParams.loyalty_id, tax.id, tax, function (success, data) {
                                if (success) {
                                    popup.tax = data;
                                    getTaxes(function (success) {
                                        if (success) {
                                            popup.closeModal();
                                        }
                                    });
                                }
                            });
                        } else {
                            LoyaltyService.AddTax($routeParams.loyalty_id, tax, function (success, data) {
                                if (success) {
                                    popup.tax = data;
                                    getTaxes(function (success) {
                                        if (success) {
                                            popup.closeModal();
                                        }
                                    });
                                }

                            });
                        }

                    };
                    popup.closeModal = function (exit) {
                        $uibModalInstance.close();
                    };

                }
            });
        };

        $scope.openModalCardCategory = function (category) {

            $uibModal.open({
                animation: true,
                keyboard: true,
                backdrop: 'static',
                size: 'lg',
                templateUrl: 'app/pages/loyalty/modals/customer-category/modal.edit-customer-category.html',
                controllerAs: 'popup',
                windowTopClass: 'modal-center',
                controller: function ($uibModalInstance) {
                    var popup = this,
                        loader = blockUI.instances.get('image-loader'),
                        loaderModal = blockUI.instances.get('loader-modal');
                    popup.dontUseBonuses = false;
                    loaderModal.start();

                    popup.currentTab = 'add_edit_category';
                    popup.step = 0;
                    popup.data = {
                        hideEnable: true
                    };

                    popup.priceOptionsValueDependsTypes = [
                        {id: 'none', title: 'price_option_value_depends_type#none'},
                        {id: 'amount', title: 'price_option_value_depends_type#amount'},
                        {id: 'quantity', title: 'price_option_value_depends_type#quantity'}
                    ];

                    popup.priceOptionsValueDependsCalcPeriod = [
                        {id: 'all', title: 'For all time'},
                        {id: 'day', title: 'For day'},
                        {id: 'week', title: 'For week'},
                        {id: 'month', title: 'For months'},
                        {id: 'three-month', title: 'For three months'},
                        {id: 'year', title: 'For year'},
                        {id: 'current-week', title: 'For this week (since Monday)'},
                        {id: 'past-week', title: 'For last week (since Monday)'},
                        {id: 'current-month', title: 'For current month (from the 1st)'},
                        {id: 'past-month', title: 'For last month (from the 1st of the last month)'},
                        {id: 'current-quarter', title: 'For current quarter'},
                        {id: 'past-quarter', title: 'For last quarter'},
                        {id: 'current-year', title: 'For current year (since January 1st)'},
                        {id: 'past-year', title: 'For last year (since January 1st of the last year)'}
                    ];

                    popup.priceOptionsValueDependsByGoods = [
                        {id: 'all', title: 'price_option_value_depends_by_goods#all'},
                        {id: 'current', title: 'price_option_value_depends_by_goods#current'}
                    ];

                    popup.priceOptionsTypes = [
                        {id: 'markup', title: 'price_option_type#markup'},
                        {id: 'discount', title: 'price_option_type#discount'},
                        {id: 'value', title: 'price_option_type#value'},
                        {id: 'forbidden', title: 'price_option_type#forbidden'},
                    ];

                    popup.priceOptionsBaseValueTypes = [
                        {id: 'posted-price', title: 'price_option_base_value_type#posted-price'},
                        {id: 'price-including-taxes', title: 'price_option_base_value_type#price-including-taxes'},
                        {id: 'base-price', title: 'price_option_base_value_type#base-price'}
                    ];

                    popup.priceOptionsValueTypes = [
                        {id: 'amount', title: 'price_option_value_type#amount'},
                        {id: 'percentage', title: 'price_option_value_type#percentage'}
                    ];

                    popup.validation = {
                        isItemValid: true,
                        isValueValid: true
                    };

                    popup.currencyList = [];


                    popup.onChangeTab = function (tab) {
                        popup.currentTab = tab;
                        popup.step = 0;
                        popup.newPriceOption = null;
                        popup.priceOptions = [];
                        if (tab == 'price_modification_currency') {
                            BusinessService.CurrencyList(undefined, function (success, response) {
                                if (success) {
                                    for (var i in response) {
                                        popup.currencyList.push({id: response[i], title: response[i]});
                                    }
                                    popup.currency = popup.currencyList[0];
                                    popup.refreshPriceOptionsCurrency(function () {
                                        popup.newPriceOption = undefined;
                                    });
                                }
                            });
                        }
                    }

                    if (category) {
                        LoyaltyService.GetCardCategories(category.loyalty_id, category.id, function (success, data) {
                            popup.category = data;
                            popup.dontUseBonuses = (parseInt(popup.category.extended_settings.bonus_payment_limit) == 0) ||
                                (popup.category.extended_settings.bonus_payment_limit === null) || false;
                            loaderModal.stop();
                        })
                    }

                    if (!category) {
                        LoyaltyService.LoyaltySettings($routeParams.loyalty_id, function (success, data) {
                            popup.category = {
                                active: 1,
                                active_change_allowed: true,
                                loyalty_id: $routeParams.loyalty_id,
                                notify_customers: 0,
                                public_title: {
                                    en: '',
                                    pl: '',
                                    ru: '',
                                    uk: ''
                                },
                                show_to_customers: 0,
                                title: '',
                                title_change_allowed: true,
                                weight: 1,
                                weight_change_allowed: true,
                                extended_settings: {
                                    bonus_payment_individual_settings: 0,
                                    bonus_payment_limit: 100,
                                    bonus_payment_limit_allowed_by_tp: data.bonus_payment_limit_allowed_by_tp,
                                    bonus_payment_type: "partial-rounded",
                                    bonus_payment_type_allowed_by_tp: data.bonus_payment_limit_allowed_by_tp
                                }
                            };
                            loaderModal.stop();
                        });
                    }

                    popup.platformSupportedLanguagesCodes = angular.copy($scope.platformSupportedLanguagesCodes);

                    popup.categoryLang = $scope.multilang.lang;
                    popup.corruptedFields = [];
                    popup.paymentTypes = $scope.data.bonus_payment_types;

                    popup.onChangeBonusPaymentType = function () {
                        switch (popup.category.extended_settings.bonus_payment_type) {
                            case 'partial':
                                break;
                            case 'partial-rounded':
                                break;
                            case 'full-check':
                                popup.dontUseBonuses = false;
                                popup.category.extended_settings.bonus_payment_limit = 100;
                                break;
                        }
                    };

                    popup.changePriceOptionType = function () {
                        if (popup.newPriceOption.type === 'value') {
                            popup.newPriceOption.base_value_type = 'base-price';
                            popup.newPriceOption.value_type = 'amount';
                        }
                    };

                    popup.onChangeDontUseBonuses = function () {
                        if (popup.dontUseBonuses) {
                            popup.category.extended_settings.bonus_payment_limit = 0;
                        } else {
                            popup.category.extended_settings.bonus_payment_limit = 100;
                        }
                    };

                    popup.changeBonusPaymentLimit = function () {
                        popup.dontUseBonuses = (parseInt(popup.category.extended_settings.bonus_payment_limit) == 0) ||
                            (popup.category.extended_settings.bonus_payment_limit === null);

                        if (parseInt(popup.category.extended_settings.bonus_payment_limit) > 100) {
                            popup.category.extended_settings.bonus_payment_limit = 100;
                        }
                    };

                    popup.image = {
                        new: false,
                        src: '',
                        cropped: '',
                        delete: false
                    };

                    popup.changeTitleLang = function (lang) {
                        if (lang === undefined) {
                            lang = $scope.multilang.lang;
                        }

                        popup.categoryLang = lang;
                    };
                    popup.initImgCrop = function () {
                        angular.element(document.getElementById('cardCategoryPicture')).on('change', function (evt) {
                            loader.start();
                            var file = evt.currentTarget.files[0],
                                reader = new FileReader();

                            reader.onload = function (e) {
                                var img = new Image();

                                img.onload = function () {
                                    var canvas = document.getElementById('file-canvas'),
                                        ctx = canvas.getContext('2d'),
                                        width = img.width,
                                        height = img.height,
                                        maxAllowedSize = 2 * 1024 * 1024;

                                    if (file.size > maxAllowedSize) {
                                        const scalingFactor = Math.sqrt(maxAllowedSize / file.size);
                                        width *= scalingFactor;
                                        height *= scalingFactor;
                                    }

                                    canvas.width = width;
                                    canvas.height = height;
                                    ctx.drawImage(img, 0, 0, width, height);

                                    var quality = 1,
                                        resizedImageDataUrl;

                                    do {
                                        quality -= 0.1;
                                        resizedImageDataUrl = canvas.toDataURL('image/jpeg', quality);
                                    } while (resizedImageDataUrl.length > maxAllowedSize && quality > 0.1);

                                    $scope.$apply(function () {
                                        popup.image.new = true;
                                        popup.image.src = resizedImageDataUrl;
                                        popup.image.cropped = '';
                                        popup.image.delete = false;
                                        loader.stop();
                                    });
                                };
                                img.src = e.target.result;
                            };

                            reader.readAsDataURL(file);
                        });
                    };
                    popup.removeImage = function () {
                        if (!!popup.category.id) {
                            popup.category.image = null;
                            popup.image.src = null;
                            popup.image.new = false;
                            popup.image.cropped = '';
                            popup.image.delete = true;
                        }
                    };
                    popup.cropImage = function () {
                        loader.start();
                        $uibModal.open({
                            animation: false,
                            keyboard: true,
                            backdrop: 'static',
                            templateUrl: 'app/templates/modal.crop-image.html',
                            controllerAs: 'popup',
                            windowTopClass: 'modal-full',
                            controller: function ($uibModalInstance) {
                                var popup_crop = this;
                                popup_crop.image = angular.copy(popup.image);
                                loader.stop();

                                popup_crop.onCancelClick = function () {
                                    loader.start();
                                    $uibModalInstance.close();
                                    loader.stop();
                                }

                                popup_crop.onCropImage = function () {
                                    loader.start();
                                    popup.image = angular.copy(popup_crop.image);
                                    $uibModalInstance.close();
                                    loader.stop();
                                }
                            }
                        })
                    }

                    popup.cardCategoryValidator = {
                        isTitleValid: function (formData) {
                            var form = formData || popup.category;
                            return !!form && form.title.length;
                        },
                        isPublicTitleValid: function (formData) {
                            var form = formData || popup.category;

                            if (!!form.show_to_customers || !!form.notify_customers) {
                                if (!formData.public_title) {
                                    return false;
                                }
                                var titleNotEmpty = Object.values(form.public_title).find(function (title) {
                                    return (title && title.length) > 0 ? true : false;
                                });
                                return titleNotEmpty ? true : false;
                            }

                            return true;
                        }
                    };

                    function validateCardCategory() {
                        var validationResult = {
                            isValid: true,
                            corruptedFields: []
                        };

                        for (var validatorName in popup.cardCategoryValidator) {
                            var isValid = popup.cardCategoryValidator[validatorName](popup.category);
                            if (!isValid) {
                                validationResult.corruptedFields.push(validatorName);
                                validationResult.isValid = false;
                            }
                        }

                        return validationResult;
                    }

                    popup.saveCategory = function () {
                        loaderModal.start();
                        var validationResult = validateCardCategory();

                        popup.corruptedFields = validationResult.corruptedFields;
                        if (!validationResult.isValid) {
                            return;
                        }
                        if (!!popup.category.id) {
                            LoyaltyService.SaveCardCategories(popup.category.loyalty_id, popup.category.id, popup.category, function (success, data) {
                                if (success) {
                                    popup.category = data;
                                    NotifyService.Success(data.message, false);
                                    if (popup.image.delete) {
                                        LoyaltyService.RemoveImageCardCategories(popup.category.loyalty_id, popup.category.id, function (success, data) {
                                            popup.category = data;
                                            getLoyaltyCardCategories(function (success, response) {
                                                if (success) {
                                                    $scope.data.cardCategories = angular.copy(response);
                                                }
                                            });
                                            loaderModal.stop();
                                            popup.closeModal();
                                        });
                                    } else {
                                        if (popup.image.new) {
                                            var image = popup.image.cropped || popup.image.src;
                                            LoyaltyService.UploadImageCardCategories(popup.category.loyalty_id, popup.category.id, image,
                                                function (success) {
                                                    loaderModal.stop();
                                                    if (success) {
                                                        getLoyaltyCardCategories(function (success, response) {
                                                            if (success) {
                                                                $scope.data.cardCategories = angular.copy(response);
                                                            }
                                                        });
                                                        popup.closeModal();
                                                    }
                                                });
                                        } else {
                                            loaderModal.stop();
                                            getLoyaltyCardCategories(function (success, response) {
                                                if (success) {
                                                    $scope.data.cardCategories = angular.copy(response);
                                                }
                                            });
                                            popup.closeModal();
                                        }
                                    }

                                }
                            });
                        } else {
                            LoyaltyService.AddCardCategories(popup.category.loyalty_id, popup.category, function (success, data) {
                                if (success) {
                                    popup.category = data;
                                    NotifyService.Success(data.message, false);
                                    if (popup.image.new) {
                                        var image = popup.image.cropped || popup.image.src;
                                        LoyaltyService.UploadImageCardCategories(popup.category.loyalty_id, popup.category.id, image,
                                            function (success) {
                                                loaderModal.stop();
                                                if (success) {
                                                    getLoyaltyCardCategories(function (success, response) {
                                                        if (success) {
                                                            $scope.data.cardCategories = angular.copy(response);
                                                        }
                                                    });
                                                    popup.closeModal();
                                                }
                                            });
                                    } else {
                                        loaderModal.stop();
                                        getLoyaltyCardCategories(function (success, response) {
                                            if (success) {
                                                $scope.data.cardCategories = angular.copy(response);
                                            }
                                        });
                                        popup.closeModal();
                                    }
                                }

                            });
                        }

                    };


                    // Price Modification Special accounts

                    popup.getSpecialAccounts = function () {
                        BusinessService.SpecialAccountsParams({scope: 'retail'}, function (success, data) {
                            if (success) {
                                popup.data.accountsList = data;
                            }
                        });
                    };
                    popup.getSpecialAccounts();
                    popup.showPriceOptions = function (account) {
                        popup.step = 1;
                        popup.selectedSpecialAccount = account;
                        popup.refreshPriceOptions();

                    };
                    popup.cancelPriceOption = function () {
                        popup.newPriceOption = undefined;
                        popup.validation.isItemValid = true;
                        popup.validation.isValueValid = true;
                        popup.step = 0;
                    };
                    popup.deletePriceOption = function (priceOption) {
                        LoyaltyService.DeleteCategorySpecialAccountPriceOption(
                            popup.category.loyalty_id,
                            popup.category.id,
                            popup.selectedSpecialAccount.id,
                            priceOption.item_id,
                            function (success, data) {
                                if (success) {
                                    NotifyService.Success('', false);
                                    popup.step = 1;
                                    popup.refreshPriceOptions(function () {
                                        popup.newPriceOption = undefined;
                                    });
                                } else {
                                    NotifyService.Error(data.message, false);
                                    popup.loading = false;
                                }
                            }
                        );
                    };
                    popup.refreshPriceOptions = function (callback) {
                        LoyaltyService.GetCategorySpecialAccountPriceOptions(popup.category.loyalty_id, popup.category.id, popup.selectedSpecialAccount.id, function (success, data) {
                            if (success) {
                                popup.priceOptions = data;
                                if (callback) {
                                    callback();
                                }
                            }
                        });
                    };
                    popup.editPriceOption = function (row) {
                        popup.step = 2;
                        popup.newPriceOption = row;
                    };
                    popup.AddPriceOption = function () {
                        popup.step = 2;
                        BusinessService.getSpecialAccountGoods(popup.selectedSpecialAccount.id, function (success, data) {
                            if (success) {
                                popup.availableSpecialAccountGoods = data;

                                popup.newPriceOption = {
                                    type: 'markup',
                                    base_value_type: 'posted-price',
                                    value_type: 'amount',
                                    value: null,
                                    value_depends_type: 'none'
                                };
                                popup.loading = true;
                            }
                        });
                    };
                    popup.savePriceOption = function () {
                        var priceOption = angular.copy(popup.newPriceOption);
                        console.log('savePriceOption::priceOption', priceOption);

                        if (priceOption.type !== 'forbidden') {
                            popup.validation.isValueValid = priceOption.value !== null && priceOption.value !== undefined && priceOption.value_depends_type === 'none';
                        } else {
                            popup.validation.isValueValid = true;
                        }

                        popup.validation.isItemValid = !!priceOption.item_id;

                        console.log('savePriceOption::priceOption', priceOption);

                        var invalidPriceOption = false;

                        if (priceOption.type !== 'forbidden') {
                            if (priceOption.value_depends_type === 'none' && (priceOption.value === null || priceOption.value === undefined)) {
                                invalidPriceOption = priceOption.value === undefined || priceOption.value === null;
                            } else if (priceOption.value_depends_type !== 'none') {
                                var isInvalidIndex = (popup.newPriceOption.value_depends_matrix || []).findIndex(function (row) {
                                    return row.value === null;
                                });
                                if (isInvalidIndex !== -1) {
                                    invalidPriceOption = true;
                                }
                            }
                        }

                        console.log('savePriceOption::invalidPriceOption', invalidPriceOption);
                        if (!priceOption.item_id || invalidPriceOption) {
                            return;
                        }
                        popup.loading = true;

                        if (priceOption.item_title) {
                            console.log('popup.savePriceOption', priceOption);
                            LoyaltyService.SaveCategorySpecialAccountPriceOption(
                                popup.category.loyalty_id,
                                popup.category.id,
                                popup.selectedSpecialAccount.id,
                                priceOption.item_id,
                                priceOption,
                                function (success, data) {
                                    if (success) {
                                        NotifyService.Success('', false);
                                        popup.step = 1;
                                        popup.refreshPriceOptions(function () {
                                            popup.newPriceOption = undefined;
                                        });
                                    } else {
                                        NotifyService.Error(data.message, false);
                                        popup.loading = false;
                                    }

                                });
                        } else {
                            LoyaltyService.AddCategorySpecialAccountPriceOption(
                                popup.category.loyalty_id,
                                popup.category.id,
                                popup.selectedSpecialAccount.id,
                                priceOption,
                                function (success, data) {
                                    if (success) {
                                        NotifyService.Success('', false);
                                        popup.step = 1;
                                        popup.refreshPriceOptions(function () {
                                            popup.newPriceOption = undefined;
                                        });
                                    } else {
                                        NotifyService.Error(data.message, false);
                                        popup.loading = false;
                                    }

                                }
                            );
                        }
                    };
                    popup.onDependsTypeSelect = function () {
                        if (popup.newPriceOption.value_depends_type === 'none') {
                            delete popup.newPriceOption.value_depends_matrix;
                            delete popup.newPriceOption.value_depends_calc_period;
                            delete popup.newPriceOption.value_depends_by_goods;
                            popup.validation.isValueValid = !!popup.newPriceOption.value;
                        } else {
                            if (!popup.newPriceOption.value_depends_matrix) {
                                popup.newPriceOption.value_depends_matrix = [
                                    {threshold: 0, value: null}
                                ];
                            }
                            if (!popup.newPriceOption.value_depends_calc_period) {
                                popup.newPriceOption.value_depends_calc_period = 'all';
                            }
                            if (!popup.newPriceOption.value_depends_by_goods) {
                                popup.newPriceOption.value_depends_by_goods = 'all';
                            }
                            popup.validation.isValueValid = true;
                        }
                    };
                    popup.isRuleValueCurrent = function (item) {
                        return item == popup.editingRule;
                    };
                    popup.ruleValueEditClick = function (value) {
                        popup.isRuleValueEdit = true;
                        popup.editingRule = value;
                        popup.backupRule = angular.copy(value);
                    };
                    popup.ruleValueDeleteClick = function (value) {
                        if (popup.newPriceOption.value_depends_matrix.length === 1) {
                            popup.newPriceOption.value_depends_matrix = [
                                {threshold: 0, value: null}
                            ];

                            popup.ruleValueEditClick(popup.newPriceOption.value_depends_matrix[0]);
                            return;
                        }
                        popup.newPriceOption.value_depends_matrix.forEach(function (item) {
                            if (item == value) {
                                popup.newPriceOption.value_depends_matrix.splice(popup.newPriceOption.value_depends_matrix.indexOf(value), 1);
                            }
                        });
                    };
                    popup.onCancelRuleValue = function () {
                        popup.isRuleValueEdit = false;
                        if (popup.isRuleValueAdd) {
                            popup.ruleValueDeleteClick(popup.editingRule);
                        } else {
                            popup.editingRule.card_category_id = popup.backupRule.card_category_id;
                            popup.editingRule.threshold = popup.backupRule.threshold;
                            popup.backupRule = null;
                            popup.editingRule = null;
                        }

                        popup.isRuleValueAdd = false;
                    };
                    popup.onAddRuleThreshold = function (fromFields) {
                        var value_is_null_index = popup.newPriceOption.value_depends_matrix.findIndex(function (v) {
                            return v.value === null;
                        });

                        if (value_is_null_index !== -1) {
                            if (fromFields['rule_value_' + value_is_null_index])
                                fromFields['rule_value_' + value_is_null_index].$dirty = true;
                            if (fromFields['rule_threshold_' + value_is_null_index])
                                fromFields['rule_threshold_' + value_is_null_index].$dirty = true;
                            return;
                        }

                        popup.newrule = {
                            threshold: 0,
                            value: null
                        };
                        popup.isRuleValueAdd = true;
                        popup.isRuleValueEdit = true;
                        popup.newPriceOption.value_depends_matrix.push(popup.newrule);
                        popup.editingRule = popup.newrule;
                    };
                    popup.onSaveRuleValue = function (item, index, form) {
                        var rule_values_error = false;
                        for (var i in form.$error.required) {
                            if (!rule_values_error && /(rule_value_|rule_threshold_)/.test(form.$error.required[i].$name)) {
                                rule_values_error = true;
                            }
                        }
                        if (item && !rule_values_error) {
                            var existThreshold = false;
                            var existValue = false;

                            popup.newPriceOption.value_depends_matrix.forEach(function (item) {
                                if (!(item == popup.editingRule) && (item.threshold == popup.editingRule.threshold)) existThreshold = true;
                                //if (!(item == popup.editingRule) && (item.value == popup.editingRule.value)) existValue = true;
                            });

                            if (existThreshold) {
                                NotifyService.Warning('Threshold with same value exists!', false);
                                // } else if (existValue) {
                                //   NotifyService.Warning('Price with same value exists!', false);
                            } else {
                                // OK, store
                                popup.isRuleValueEdit = false;
                                popup.isRuleValueAdd = false;
                                popup.editingRule = null;
                                popup.backupRule = null;

                                var orderBy = $filter('orderBy');
                                popup.newPriceOption.value_depends_matrix = orderBy(popup.newPriceOption.value_depends_matrix, 'threshold', false);
                            }
                        } else {
                            if (form['rule_value_' + index])
                                form['rule_value_' + index].$dirty = true;
                            if (form['rule_threshold_' + index])
                                form['rule_threshold_' + index].$dirty = true;
                        }
                    };


                    // Price modification currency


                    popup.showPriceOptionsCurrency = function (account) {
                        popup.step = 1;
                        popup.selectedSpecialAccount = account;
                        popup.refreshPriceOptionsCurrency();

                    };

                    popup.cancelPriceOptionCurrency = function () {
                        popup.newPriceOption = undefined;
                        popup.validation.isItemValid = true;
                        popup.validation.isValueValid = true;
                        popup.step = 0;
                    };

                    popup.deletePriceOptionCurrency = function (priceOption) {
                        LoyaltyService.DeleteCategoryCurrencyPriceOption(
                            popup.category.loyalty_id,
                            popup.category.id,
                            popup.currency.id,
                            priceOption.item_id,
                            function (success, data) {
                                if (success) {
                                    NotifyService.Success('', false);
                                    popup.step = 0;
                                    popup.refreshPriceOptionsCurrency(function () {
                                        popup.newPriceOption = undefined;
                                    });
                                } else {
                                    popup.loading = false;
                                    NotifyService.Error(data.message, false);
                                }

                            }
                        );
                    };

                    popup.refreshPriceOptionsCurrency = function (callback) {
                        popup.priceOptions = []
                        LoyaltyService.GetCategoryCurrencyPriceOptions(popup.category.loyalty_id, popup.category.id, popup.currency.id, function (success, data) {
                            if (success) {
                                popup.priceOptions = data;
                                if (callback) {
                                    callback();
                                }
                            }
                        });
                    };

                    popup.editPriceOptionCurrency = function (row) {
                        popup.step = 1;
                        popup.newPriceOption = row;
                    };

                    popup.changeCurrency = function () {
                        popup.refreshPriceOptionsCurrency();
                    }

                    popup.AddPriceOptionCurrency = function () {
                        popup.step = 1;

                        popup.loadAvailableGoods = function (searchTerm) {
                            var post_data = {
                                count: 40,
                                page: 1,
                                only_active: false,
                                service_type: 'all',
                                search_text: searchTerm,
                            }
                            GoodsService.GoodsInLoyalty(popup.category.loyalty_id, post_data, function (success, data) {
                                if (success) {
                                    popup.availableGoods = data.data
                                }
                            })
                        }

                        popup.newPriceOption = {
                            type: 'markup',
                            base_value_type: 'posted-price',
                            value_type: 'amount',
                            value: null,
                            value_depends_type: 'none'
                        };
                        popup.loading = true;
                    };

                    popup.savePriceOptionCurrency = function () {
                        var priceOption = angular.copy(popup.newPriceOption);
                        console.log('savePriceOption::priceOption', priceOption);

                        if (priceOption.type !== 'forbidden') {
                            popup.validation.isValueValid = priceOption.value !== null && priceOption.value !== undefined && priceOption.value_depends_type === 'none';
                        } else {
                            popup.validation.isValueValid = true;
                        }

                        popup.validation.isItemValid = !!priceOption.item_id;

                        console.log('savePriceOption::priceOption', priceOption);

                        var invalidPriceOption = false;

                        if (priceOption.type !== 'forbidden') {
                            if (priceOption.value_depends_type === 'none' && (priceOption.value === null || priceOption.value === undefined)) {
                                invalidPriceOption = priceOption.value === undefined || priceOption.value === null;
                            } else if (priceOption.value_depends_type !== 'none') {
                                var isInvalidIndex = (popup.newPriceOption.value_depends_matrix || []).findIndex(function (row) {
                                    return row.value === null;
                                });
                                if (isInvalidIndex !== -1) {
                                    invalidPriceOption = true;
                                }
                            }
                        }

                        console.log('savePriceOption::invalidPriceOption', invalidPriceOption);
                        if (!priceOption.item_id || invalidPriceOption) {
                            return;
                        }
                        popup.loading = true;

                        if (priceOption.item_title) {
                            console.log('popup.savePriceOption', priceOption);
                            LoyaltyService.SaveCategoryCurrencyPriceOption(
                                popup.category.loyalty_id,
                                popup.category.id,
                                popup.currency.id,
                                priceOption.item_id,
                                priceOption,
                                function (success, data) {
                                    if (success) {
                                        NotifyService.Success('', false);
                                        popup.step = 0;
                                        popup.refreshPriceOptionsCurrency(function () {
                                            popup.newPriceOption = undefined;
                                        });
                                    } else {
                                        popup.loading = false;
                                        NotifyService.Error(data.message, false);
                                    }

                                });
                        } else {
                            LoyaltyService.AddCategoryCurrencyPriceOption(
                                popup.category.loyalty_id,
                                popup.category.id,
                                popup.currency.id,
                                priceOption,
                                function (success, data) {
                                    if (success) {
                                        NotifyService.Success('', false);
                                        popup.step = 0;
                                        popup.refreshPriceOptionsCurrency(function () {
                                            popup.newPriceOption = undefined;
                                        });
                                    } else {
                                        popup.loading = false;
                                        NotifyService.Error(data.message, false);
                                    }
                                }
                            );
                        }
                    };

                    popup.closeModal = function (exit) {
                        $uibModalInstance.close();
                    };

                }
            });
        };

        // *********************************************************************************************
        //  CREATE & EDIT LOYALTY RULES
        // *********************************************************************************************

        $scope.getActiveRules = function () {
            var a = 0;

            if ($scope.data.loyaltyRules)
                for (var i in $scope.data.loyaltyRules)
                    if ($scope.data.loyaltyRules[i].active === 1)
                        a++;

            return a;
        };

        /**
         * Disable/enable rules
         */
        $scope.onRuleToggleClick = function (rule) {
            rule.active = rule.active == 0 ? 1 : 0;
            LoyaltyService.ChangeLoyaltyRule(rule.loyalty_id, rule.id, rule, function (success, data) {
                if (success)
                    NotifyService.Success('', false);
                else
                    rule.active = rule.active == 0 ? 1 : 0;
            });
        };

        $scope.changeRuleAutomatic = function (rule) {
            if ($scope.isRuleCorporate(rule) !== $scope.isRuleCorporate(previousRule)) {
                if ($scope.isRuleCorporate(rule)) {
                    rule.action_type = $scope.data.action_types_corporate[0].id;
                } else {
                    rule.action_type = $scope.data.action_types[0].id;
                }
            }

            previousRule = angular.copy(rule);
        }

        // $scope.posesLoadComplete = function (items) {$scope.formDataComplete.poses = true;};
        // $scope.accountsLoadComplete = function (items) {$scope.formDataComplete.accounts = true};
        // $scope.categoriesLoadComplete = function (items) {$scope.formDataComplete.categories = true};
        // $scope.formDataLoadComplete = function () {
        //     return ($scope.formDataComplete.poses && $scope.formDataComplete.accounts && $scope.formDataComplete.categories);
        // };

        function getCorporateCategoriesList() {
            CorporateCustomerService.GetCorporateCustomersCategories(function (success, response) {
                if (success) {
                    $scope.data.corporateCustomerCategories = response;
                    $scope.data.corporateCustomerCategories.unshift({id: '0', title: 'For all customers', active: 1});
                }
            });
        }


        function getPOSList(callback) {
            SelectService.getPOSList(function (success, response) {
                if (success) {
                    var r = response,
                        p = [];

                    for (var i in r)
                        if (r[i].loyalty_id === $scope.model.id)
                            p.push(r[i]);

                    for (var i in $scope.rule.pos)
                        $scope.rule.pos[i] = itemByIndex(p, $scope.rule.pos[i].id);

                    $scope.model.POSList = p;
                    if (callback) {
                        callback(success, response);
                    }
                }
            });
        }

        function getAccountsList() {
            $scope.makeAccountsList(function (data) {
                if (data) {
                    $scope.model.specialAccountsList = [];
                    for (var i in data)
                        // if (data[i].active === 1)
                        //     $scope.model.specialAccountsList.push(data[i]);
                        $scope.model.specialAccountsList.push(data[i]);

                    if ($scope.model.specialAccountsList.length > 0)
                        if ($scope.rule.special_account_id)
                            $scope.rule.special_account = itemByIndex($scope.model.specialAccountsList, $scope.rule.special_account_id);
                        else
                            $scope.rule.special_account = $scope.model.specialAccountsList[0];
                }
            });
        }

        function getCouponBatchesList() {
            var params = {
                page: 1,
                count: 500,
                loyalty: $scope.model.id
            };

            $scope.model.couponBatches = [];

            CouponsService.Batches(params, function (success, data) {
                if (success) {
                    $scope.model.couponBatchesList = angular.copy(data.data);

                    if ($scope.model.couponBatchesList.length > 0) {
                        if ($scope.rule.coupon_batch_code) {
                            $scope.rule.coupon_batch = itemByIndex($scope.model.couponBatchesList, $scope.rule.coupon_batch_code, 'code');
                        } else {
                            $scope.rule.coupon_batch = $scope.model.couponBatchesList[0];
                        }
                        $scope.rule.coupon_batch_code = $scope.rule.coupon_batch.code;
                    }
                }
            });
        }

        function getGoods(callback) {
            $scope.model.goodsList = [];

            function handleResult(success, result) {
                if (success) {
                    $scope.model.goodsList = $scope.model.goodsList.concat(result);
                    callback(true);
                }
            }

            EmbeddedService.GetGoods({ loyalty_id: $scope.model.id, service_type: 'all' }, handleResult)
        }

        function getGoodsCategories(callback) {
            $scope.getGoodsCategoriesList($scope.model.id, function (success, response) {
                if (success)
                    $scope.model.categoriesList = angular.copy($rootScope.GOODS_CATEGORIES_FLAT[$scope.model.id]);

                callback(true);
            });
        }

        $scope.onEditCategoryRule = function (card_category_rule) {
            $scope.onAddCategoryRule(card_category_rule);
        };

        $scope.isRuleCorporate = function (rule) {
            return rule.automatic == 4 || rule.automatic == 5;
        }

        $scope.onCategoryRuleToggleClick = function (rule) {
            rule.active = rule.active == 0 ? 1 : 0;

            LoyaltyService.SaveCardCategoriesRule(rule.loyalty_id, rule.id, {
                id: rule.id,
                active: rule.active
            }, function (success, data) {
                if (success)
                    NotifyService.Success('', false);
                else
                    rule.active = rule.active == 0 ? 1 : 0;
            });

            // LoyaltyService.ChangeLoyaltyRule(rule.id, rule, function (success, data) {
            //     if (success)
            //         NotifyService.Success('', false);
            //     else
            //         rule.active = rule.active == 0 ? 1 : 0;
            // });
        };
        $scope.onAddCategoryRule = function (card_category_rule) {
            var maxPriority = 1;
            $scope.data.categoryRules.forEach(function (item) {
                if (item.priority > maxPriority) maxPriority = item.priority;
            });

            var start_of_the_day = new Date();
            start_of_the_day.setHours(0, 0, 0, 0);

            var end_of_the_day = new Date();
            end_of_the_day.setHours(23, 59, 59, 999);

            $uibModal.open({
                animation: true,
                keyboard: true,
                backdrop: 'static',
                size: 'lg',
                templateUrl: 'app/templates/modal.card-category-rule.html',
                controllerAs: 'popup',
                windowTopClass: 'modal-center',
                controller: function ($uibModalInstance) {

                    var popup = this;

                    popup.onRuleTypeSelect = function () {

                        if (popup.card_category_rule.action_type === 'category-change-by-amount') {
                            popup.rule_depends = [
                                {id: 'amount', title: 'Amount'},
                                {id: 'bonuses-earned', title: 'depends type bonuses earned'},
                                {id: 'bonuses-on-account', title: 'depends type bonuses on account'},
                                {id: 'none', title: 'No dependence'}
                            ];
                        } else if (popup.card_category_rule.action_type === 'category-change-by-item') {
                            popup.rule_depends = [
                                {id: 'amount', title: 'Amount'},
                                {id: 'quantity', title: 'Quantity'},
                                {id: 'none', title: 'No dependence'}
                            ];
                        }

                        if (popup.card_category_rule.depends_type === 'bonuses-on-account') {
                            popup.card_category_rule.depends_calc_period = 'all';
                        } else if (popup.card_category_rule.depends_type === 'none') {
                            // popup.card_category_rule.value[0].threshold = 0;
                            // depends_calc_period обязательный
                        }

                        popup.card_category_rule.comment = $filter('translate')(
                            itemByIndex(popup.action_types, popup.card_category_rule.action_type).title);

                    };

                    popup.action_allowed = [
                        {id: 'any-weight', title: 'Card-category-rule#any-weight'},
                        {id: 'greater-weight-only', title: 'Card-category-rule#greater-weight-only'},
                        {id: 'less-weight-only', title: 'Card-category-rule#less-weight-only'}
                    ];

                    popup.action_types = [
                        {id: 'category-change-by-amount', title: 'Card-category-rule#category-change-by-amount'},
                        {id: 'category-change-by-item', title: 'Card-category-rule#category-change-by-item'}
                    ];

                    popup.week_days = angular.copy($scope.data.week_days);

                    popup.POSList = [];
                    getPOSList(function (success, response) {
                        popup.POSList = angular.copy($scope.model.POSList);
                    });

                    popup.cardCategoriesWithoutAll = [];
                    popup.cardCategories = [];
                    getLoyaltyCardCategories(function (success, response) {
                        if (success) {

                            var cardCategories = response;
                            popup.cardCategoriesWithoutAll = angular.copy(cardCategories);

                            cardCategories.unshift({id: '0', title: 'For all customers', active: 1});
                            popup.cardCategories = angular.copy(cardCategories);
                        }
                    });

                    popup.rule_period = angular.copy($scope.data.rule_period);
                    popup.rule_depends = [
                        {id: 'amount', title: 'Amount'},
                        {id: 'bonuses-earned', title: 'depends type bonuses earned'},
                        {id: 'bonuses-on-account', title: 'depends type bonuses on account'},
                        {id: 'none', title: 'No dependence'}
                    ];
                    popup.currenciesList = angular.copy($scope.data.currenciesList);

                    popup.isNeedLimit = function () {
                        var a = ['category-change-by-item'];
                        return a.indexOf(popup.card_category_rule.action_type) > -1;
                    };
                    popup.staff = {
                        is_limit_max_count: false,
                        is_limit_min_count: false,
                        boonValue: 0
                    };

                    popup.onLimitMaxEnable = function () {
                        if (popup.staff.is_limit_max_count && popup.card_category_rule.items_limit_max < popup.card_category_rule.items_limit_min) {
                            popup.card_category_rule.items_limit_max = popup.card_category_rule.items_limit_min;
                        }
                    };

                    popup.onLimitMinEnable = function () {
                        if (popup.staff.is_limit_min_count && popup.card_category_rule.items_limit_max < popup.card_category_rule.items_limit_min) {
                            popup.card_category_rule.items_limit_min = popup.card_category_rule.items_limit_max;
                        }
                    };
                    popup.isRuleValueCurrent = function (item) {
                        return item == popup.editingRule;
                    };

                    popup.ruleValueEditClick = function (value) {
                        popup.isRuleValueEdit = true;
                        popup.editingRule = value;
                        popup.backupRule = angular.copy(value);
                    };

                    popup.ruleValueDeleteClick = function (value) {

                        if (popup.card_category_rule.value.length === 1) {
                            popup.card_category_rule.value[0] = {
                                threshold: 0,
                                card_category_id: null
                            };
                            popup.ruleValueEditClick(popup.card_category_rule.value[0]);
                            return;
                        }

                        popup.card_category_rule.value.forEach(function (item) {
                            if (item == value) {
                                popup.card_category_rule.value.splice(popup.card_category_rule.value.indexOf(value), 1);
                            }
                        });
                    };
                    popup.onCancelRuleValue = function () {
                        // if (popup.card_category_rule.value.length === 1) {
                        //
                        //     popup.card_category_rule.value[0].card_category_id = null;
                        //     popup.backupRule = null;
                        //     popup.isRuleValueAdd = false;
                        //     return;
                        // }

                        popup.isRuleValueEdit = false;

                        if (popup.isRuleValueAdd) {
                            popup.ruleValueDeleteClick(popup.editingRule);
                        } else {
                            popup.editingRule.card_category_id = popup.backupRule.card_category_id;
                            popup.editingRule.threshold = popup.backupRule.threshold;
                            popup.backupRule = null;
                            popup.editingRule = null;
                        }

                        popup.isRuleValueAdd = false;
                    };

                    popup.onSaveRuleValue = function (item, index, form) {
                        var rule_values_error = false;
                        for (var i in form.$error.required) {
                            if (!rule_values_error && /(rule_card_category_id_|rule_threshold_)/.test(form.$error.required[i].$name)) {
                                rule_values_error = true;
                            }
                        }

                        if (item && !rule_values_error) {
                            var existThreshold = false;
                            var existCategory = false;

                            popup.card_category_rule.value.forEach(function (item) {
                                if (!(item == popup.editingRule) && (item.threshold == popup.editingRule.threshold)) existThreshold = true;
                                if (!(item == popup.editingRule) && (item.card_category_id == popup.editingRule.card_category_id)) existCategory = true;
                            });

                            if (existThreshold) {
                                NotifyService.Warning('Threshold with same value exists!', false);
                            } else if (existCategory) {
                                NotifyService.Warning('Category with same value exists!', false);
                            } else {
                                // OK, store
                                popup.isRuleValueEdit = false;
                                popup.isRuleValueAdd = false;
                                popup.editingRule = null;
                                popup.backupRule = null;

                                var orderBy = $filter('orderBy');
                                popup.card_category_rule.value = orderBy(popup.card_category_rule.value, 'threshold', false);
                            }
                        } else {
                            if (form['rule_card_category_id_' + index])
                                form['rule_card_category_id_' + index].$dirty = true;
                            if (form['rule_threshold_' + index])
                                form['rule_threshold_' + index].$dirty = true;
                        }
                    };
                    popup.onAddRuleThreshold = function (fromFields) {
                        var card_category_id_is_null_index = popup.card_category_rule.value.findIndex(function (v) {
                            return v.card_category_id === null;
                        });

                        if (card_category_id_is_null_index !== -1) {

                            if (fromFields['rule_card_category_id_' + card_category_id_is_null_index])
                                fromFields['rule_card_category_id_' + card_category_id_is_null_index].$dirty = true;
                            if (fromFields['rule_threshold_' + card_category_id_is_null_index])
                                fromFields['rule_threshold_' + card_category_id_is_null_index].$dirty = true;
                            return;
                        }

                        popup.newrule = {
                            threshold: 0,
                            card_category_id: null
                        };
                        popup.isRuleValueAdd = true;
                        popup.isRuleValueEdit = true;
                        popup.card_category_rule.value.push(popup.newrule);

                        popup.editingRule = popup.newrule;
                    };

                    popup.goodsTagHandler = function (code) {
                        return {title: '', code: code};
                    };

                    popup.categoryTagHandler = function (title) {
                        return {title: title};
                    };

                    popup.card_category_rule = card_category_rule ? card_category_rule : {
                        active: 1,
                        action_type: popup.action_types[0].id,
                        action_allowed: popup.action_allowed[0].id,
                        automatic: 1,
                        // card_category_id: '0', // ? string
                        combine: 1, // ? string
                        comment: '', // ? string
                        currency: '', // ? string
                        depends_calc_period: 'all',
                        depends_type: 'none',
                        excluded_item_categories: [],
                        excluded_items: [],
                        included_item_categories: [],
                        included_items: [],
                        use_alternative_dependencies_by_items: 0,
                        depends_included_item_categories: [],
                        depends_included_items: [],
                        depends_excluded_item_categories: [],
                        depends_excluded_items: [],
                        // items_limit_min: 0,
                        // items_limit_max: 0,
                        loyalty_id: $scope.loyaltyId,

                        priority: maxPriority + 1,
                        scheduled: 0,
                        // time_from: start_of_the_day,
                        // time_to: end_of_the_day,

                        //  valid_after : end_of_the_day,
                        //  valid_before  : end_of_the_day,
                        value: [
                            /* {'card_category_id': null, 'threshold': 0}*/
                            /* */]
                        // week_days

                    };

                    if (!popup.card_category_rule.time_from) {
                        popup.card_category_rule.time_from = moment().startOf('day').utc().toDate();
                    } else {
                        var time_from = moment().set({
                            hour: popup.card_category_rule.time_from.split(':')[0],
                            minute: popup.card_category_rule.time_from.split(':')[1],
                            second: popup.card_category_rule.time_from.split(':')[2]
                        });
                        popup.card_category_rule.time_from = moment(time_from).utc().toDate();
                    }
                    if (!popup.card_category_rule.time_to) {
                        popup.card_category_rule.time_to = moment().endOf('day').utc().toDate();
                    } else {
                        var time_to = moment().set({
                            hour: popup.card_category_rule.time_to.split(':')[0],
                            minute: popup.card_category_rule.time_to.split(':')[1],
                            second: popup.card_category_rule.time_to.split(':')[2]
                        });
                        popup.card_category_rule.time_to = moment(time_to).utc().toDate();
                    }

                    if (!popup.card_category_rule.id) {
                        // NEW
                        popup.onAddRuleThreshold();
                        if (popup.currenciesList.length === 1) {
                            popup.card_category_rule.currency = popup.currenciesList[0];
                        }
                    } else {
                        // EDIT
                        popup.staff.is_limit_max_count = popup.isNeedLimit() && popup.card_category_rule.items_limit_max > 0;
                        popup.staff.is_limit_min_count = popup.isNeedLimit() && popup.card_category_rule.items_limit_min > 0;

                        // if (!popup.staff.is_limit_max_count) {
                        //     popup.card_category_rule.items_limit_max = 1;
                        // }

                        if (popup.card_category_rule.depends_type === 'none') {
                            popup.staff.rule_card_category_id = popup.card_category_rule.value[0].card_category_id;
                        }
                    }

                    if (!popup.card_category_rule.card_category_id) {
                        popup.card_category_rule.card_category_id = '0';
                    }

                    function _makeDictTag(goodsList, showTitle) {
                        var result = [];

                        if (goodsList) {
                            if (showTitle) {
                                goodsList.forEach(function (goodItem) {
                                    var searchedItem = $scope.model.goodsList.find(function (item) {
                                        if (item.title === goodItem || item.code === goodItem) {
                                            return true;
                                        }
                                    });

                                    if (searchedItem) {
                                        result.push({
                                            title: searchedItem.title,
                                            isTag: true,
                                            code: searchedItem.code
                                        });
                                    } else {
                                        result.push({
                                            title: goodItem,
                                            isTag: true,
                                            code: goodItem
                                        });
                                    }

                                });
                            } else {
                                goodsList.forEach(function (goodItem) {
                                    var searchedItemForFalse = $scope.model.goodsList.find(function (item) {
                                        if (item.title === goodItem) {
                                            return true;
                                        }
                                    });

                                    if (searchedItemForFalse) {
                                        result.push(searchedItemForFalse);
                                    } else {
                                        result.push({code: goodItem});
                                    }

                                });
                            }
                        }
                        return result;
                    }

                    popup.categoriesList = [];
                    getGoodsCategories(function (success) {
                        if (success) {
                            popup.card_category_rule.included_item_categories = _makeDictTag(popup.card_category_rule.included_item_categories, true);
                            popup.card_category_rule.excluded_item_categories = _makeDictTag(popup.card_category_rule.excluded_item_categories, true);

                            popup.card_category_rule.depends_included_item_categories = _makeDictTag(popup.card_category_rule.included_item_categories, true);
                            popup.card_category_rule.depends_excluded_items = _makeDictTag(popup.card_category_rule.excluded_item_categories, true);

                            popup.categoriesList = angular.copy($scope.model.categoriesList);
                        }
                    });

                    popup.goodsList = [];
                    getGoods(function (success) {
                        if (success) {
                            popup.card_category_rule.included_items = _makeDictTag(popup.card_category_rule.included_items, true);
                            popup.card_category_rule.excluded_items = _makeDictTag(popup.card_category_rule.excluded_items, true);

                            popup.card_category_rule.depends_included_items = _makeDictTag(popup.card_category_rule.included_items, true);
                            popup.card_category_rule.depends_excluded_items = _makeDictTag(popup.card_category_rule.excluded_items, true);

                            popup.goodsList = angular.copy($scope.model.goodsList);
                        }
                    });

                    popup.onRuleTypeSelect();

                    popup.saveCategoryRule = function (form) {
                        var card_category_rule = angular.copy(popup.card_category_rule);
                        if (card_category_rule.depends_type === 'none') {
                            delete card_category_rule.depends_calc_period;
                            card_category_rule.value = [
                                {
                                    card_category_id: popup.staff.rule_card_category_id,
                                    threshold: 0
                                }];
                        }
                        var cardCategoryIdIsNull = card_category_rule.value.find(function (v) {
                            return v.card_category_id === null;
                        });

                        if (isFormValidInModal(form) && !cardCategoryIdIsNull) {

                            card_category_rule.automatic = parseInt(card_category_rule.automatic);

                            if (!card_category_rule.time_from || !card_category_rule.time_to) {
                                delete card_category_rule.time_from;
                                delete card_category_rule.time_to;
                            } else if (card_category_rule.time_from && card_category_rule.time_to) {
                                card_category_rule.time_from = moment(card_category_rule.time_from).format('HH:mm:ss');
                                card_category_rule.time_to = moment(card_category_rule.time_to).format('HH:mm:ss');
                            }
                            // delete card_category_rule.time_from;
                            // delete card_category_rule.time_to;

                            // Reset limit
                            if (!popup.staff.is_limit_max_count)
                                card_category_rule.items_limit_max = 0;

                            if (!popup.staff.is_limit_min_count)
                                card_category_rule.items_limit_min = 0;

                            if (popup.staff.is_limit_max_count &&
                                popup.staff.is_limit_min_count &&
                                card_category_rule.items_limit_min > card_category_rule.items_limit_max) {
                                // form.items_limit_min.$invalid = form.items_limit_min.$dirty = true;
                                // form.items_limit_max.$invalid = form.items_limit_max.$dirty = true;
                                NotifyService.Warning('Please check if all data are correct.', false);
                                return;
                            }

                            // delete card_category_rule.items_limit_min;
                            // delete card_category_rule.items_limit_max;

                            if (!card_category_rule.valid_after || !card_category_rule.valid_before) {
                                delete card_category_rule.valid_after;
                                delete card_category_rule.valid_before;
                            } else if (card_category_rule.valid_after && card_category_rule.valid_before) {
                                card_category_rule.valid_after = moment(card_category_rule.valid_after).format('YYYY-MM-DD');
                                card_category_rule.valid_before = moment(card_category_rule.valid_before).format('YYYY-MM-DD');
                            }

                            var _makeTagArray = function (d, c) {
                                var result = [];
                                if (d)
                                    d.forEach(function (item) {
                                        if (c && result.indexOf('item.title') === -1)
                                            result.push(item.title);
                                        else
                                            result.push(item.code);
                                    });
                                return result.filter(function (value, index, self) {
                                    return self.indexOf(value) === index;
                                });
                            };

                            // Set products arrays
                            //if ($scope.isProductAction()) {

                            if (card_category_rule.action_type === 'category-change-by-item') {

                                card_category_rule.included_item_categories = _makeTagArray(card_category_rule.included_item_categories, true);
                                card_category_rule.included_items = _makeTagArray(card_category_rule.included_items, false);
                                card_category_rule.excluded_item_categories = _makeTagArray(card_category_rule.excluded_item_categories, true);
                                card_category_rule.excluded_items = _makeTagArray(card_category_rule.excluded_items, false);

                                if (card_category_rule.use_alternative_dependencies_by_items) {
                                    card_category_rule.depends_included_item_categories = _makeTagArray(card_category_rule.depends_included_item_categories, true);
                                    card_category_rule.depends_included_items = _makeTagArray(card_category_rule.depends_included_items, false);
                                    card_category_rule.depends_excluded_item_categories = _makeTagArray(card_category_rule.depends_excluded_item_categories, true);
                                    card_category_rule.depends_excluded_items = _makeTagArray(card_category_rule.depends_excluded_items, false);
                                }

                            } else {
                                delete card_category_rule.included_item_categories;
                                delete card_category_rule.included_items;
                                delete card_category_rule.excluded_item_categories;
                                delete card_category_rule.excluded_items;

                                card_category_rule.use_alternative_dependencies_by_items = 0;
                                delete card_category_rule.depends_included_item_categories;
                                delete card_category_rule.depends_included_items;
                                delete card_category_rule.depends_excluded_item_categories;
                                delete card_category_rule.depends_excluded_items;
                            }

                            // if (card_category_rule.card_category_id === '0') {
                            //     delete card_category_rule.card_category_id;
                            // }

                            if (!!card_category_rule.id) {
                                LoyaltyService.SaveCardCategoriesRule(card_category_rule.loyalty_id, card_category_rule.id, card_category_rule,
                                    function (success, data) {
                                        if (success) {
                                            NotifyService.Success(data.message, false);
                                            popup.card_category_rule = data;

                                            getCardCategoriesRulesList(function () {

                                            });
                                            popup.closeModal();
                                        }
                                    });
                            } else {
                                LoyaltyService.AddCardCategoriesRules(card_category_rule.loyalty_id, card_category_rule, function (success, data) {
                                    if (success) {
                                        NotifyService.Success(data.message, false);
                                        popup.card_category_rule = data;

                                        getCardCategoriesRulesList(function () {

                                        });
                                        popup.closeModal();

                                    }

                                });
                            }
                        }
                    };

                    popup.closeModal = function (exit) {
                        getCardCategoriesRulesList(function () {

                        });
                        $uibModalInstance.close();
                    };

                }
            });

        };

        /**
         * Add rule to loyalty
         */
        $scope.onAddRule = function () {

            // for (var i in $scope.data.week_days)
            //     $scope.data.week_days[i].active = true;

            var maxPriority = 1;
            $scope.data.loyaltyRules.forEach(function (item) {
                if (item.priority > maxPriority) maxPriority = item.priority;
            });

            var start_of_the_day = new Date();
            start_of_the_day.setHours(0, 0, 0, 0);

            var end_of_the_day = new Date();
            end_of_the_day.setHours(23, 59, 59, 999);

            $scope.rule = {
                active: 1,
                action_type: 'discount-percent-by-item',
                items_limit_min: 1,
                items_limit_max: 1,
                charge_type: 'regular-bonuses',
                promotional_bonuses_starting_type: 'immediately',
                promotional_bonuses_expire_type: 'date',
                depends_type: 'none',
                depends_calc_period: 'all',
                applicable_for_sale: 'all',
                card_category_id: '0',
                corporate_customer_category_id: '0',
                apply_when_bonuses_redeemed: 1,
                coupon_do_not_add_to_wallet: 0,
                depends_calc_period_related_to_current_category: 0,
                combine: 1,
                priority: maxPriority + 1,
                automatic: 1,
                value: [{'value': 0.00, 'threshold': 0}],
                coupon_by_item_issue_quantity: 1,
                loyalty_id: $scope.loyaltyId,
                time_from: start_of_the_day,
                time_to: end_of_the_day,
                applicable_for_customer: 'identified',
                applicable_api_scope: 'all',
                promotional_bonuses_expire_value: 1,
                promotional_bonuses_starting_value: 1,
                count_bonuses_redeemed_amount_brand: 1,
                promotional_bonuses_expire_date: moment().add(1, 'month').utc().toDate(),
                promotional_bonuses_starting_date: moment().utc().toDate()
            };

            $scope.model.selectedPOS = [];
            $scope.model.included_items = [];
            $scope.model.included_item_categories = [];
            $scope.model.excluded_item_categories = [];
            $scope.model.excluded_items = [];

            $scope.model.depends_included_item_categories = [];
            $scope.model.depends_included_items = [];
            $scope.model.depends_excluded_item_categories = [];
            $scope.model.depends_excluded_items = [];

            $scope.staff.is_limit_max_count = false;
            $scope.staff.is_limit_min_count = false;
            $scope.staff.boonValue = 0;
            $scope.onRuleTypeSelect();

            getCorporateCategoriesList();
            getPOSList();
            getAccountsList();
            getLoyaltyCardCategories(function (success, response) {
                if (success) {
                    $scope.data.cardCategories = response;
                    $scope.data.cardCategories.unshift({id: '0', title: 'For all customers', active: 1});
                    // // TODO Array.filter()
                    // for (var i in response)
                    //     if (response[i].active === 1)
                    //         $scope.data.cardCategories.push(response[i])

                    // $scope.data.cardCategories.unshift({id: '0', title: 'For all customers', active: 1});
                }
            });

            getGoodsCategories(function (success) {
            });
            getGoods(function (success) {
            });

            // Go to edit mode
            $scope.model.isRuleEdit = true;
            previousRule = angular.copy($scope.rule);
        };

        /**
         * Start rule edit
         */
        $scope.onRuleEdit = function (rule) {
            // $scope.formDataComplete = {};

            function _makeDictTag(goodsList, showTitle) {
                var result = [];

                if (goodsList) {
                    if (showTitle) {
                        goodsList.forEach(function (goodItem) {
                            var searchedItem = $scope.model.goodsList.find(function (item) {
                                if (item.code === goodItem) {
                                    return true;
                                }
                            });

                            if (searchedItem) {
                                result.push({
                                    title: searchedItem.title,
                                    isTag: true,
                                    code: searchedItem.code
                                });
                            } else {
                                result.push({
                                    title: goodItem,
                                    isTag: true,
                                    code: goodItem
                                });
                            }

                        });
                    } else {
                        goodsList.forEach(function (goodItem) {
                            var searchedItemForFalse = $scope.model.goodsList.find(function (item) {
                                if (item.title === goodItem) {
                                    return true;
                                }
                            });

                            if (searchedItemForFalse) {
                                result.push(searchedItemForFalse);
                            } else {
                                result.push({code: goodItem});
                            }

                        });
                    }
                }
                return result;
            }

            if (rule) {
                LoyaltyService.GetLoyaltyRule(rule.loyalty_id, rule.id, function (success, data) {
                    if (!success) {
                        return;
                    }

                    $scope.rule = angular.copy(data);
                    getPOSList();
                    getCorporateCategoriesList();
                    getAccountsList();
                    getLoyaltyCardCategories(function (success, response) {
                        if (success) {
                            $scope.data.cardCategories = response;
                            $scope.data.cardCategories.unshift({id: '0', title: 'For all customers', active: 1});
                        }
                    });

                    // Limit "wrapping"
                    $scope.staff.is_limit_max_count = $scope.isNeedLimit() && $scope.rule.items_limit_max > 0;
                    $scope.staff.is_limit_min_count = $scope.isNeedLimit() && $scope.rule.items_limit_min > 0;

                    if (!$scope.staff.is_limit_max_count)
                        $scope.rule.items_limit_max = 1;

                    if (!$scope.rule.card_category_id)
                        $scope.rule.card_category_id = '0';

                    if (!$scope.rule.corporate_customer_category_id)
                        $scope.rule.corporate_customer_category_id = '0';

                    getGoodsCategories(function (success) {
                        if (success) {
                            $scope.model.included_item_categories = _makeDictTag($scope.rule.included_item_categories, true);
                            $scope.model.excluded_item_categories = _makeDictTag($scope.rule.excluded_item_categories, true);

                            $scope.model.depends_included_item_categories = _makeDictTag($scope.rule.depends_included_item_categories, true);
                            $scope.model.depends_excluded_item_categories = _makeDictTag($scope.rule.depends_excluded_item_categories, true);
                        }
                    });

                    getGoods(function (success) {
                        if (success) {
                            $scope.model.included_items = _makeDictTag($scope.rule.included_items, true);
                            $scope.model.excluded_items = _makeDictTag($scope.rule.excluded_items, true);

                            $scope.model.depends_included_items = _makeDictTag($scope.rule.depends_included_items, true);
                            $scope.model.depends_excluded_items = _makeDictTag($scope.rule.depends_excluded_items, true);

                            if ($scope.model.included_items && $scope.model.included_items.length > 0) {
                                $scope.rule.item_zero_quantity_as_one_quantity = $scope.rule.item_zero_quantity_as_one_quantity || 0;
                            }
                        }
                    });

                    if ($scope.rule.coupon_batch_code) {
                        $scope.rule.coupon_batch = {
                            title: '',
                            code: $scope.rule.coupon_batch_code
                        };
                    }

                    if ($scope.rule.action_type === 'emission-coupon-by-item') {
                        if ($scope.rule.value[0].value == 1 || $scope.rule.value[0].value == 2 || $scope.rule.value[0].value == 3)
                            $scope.rule.coupon_by_item_issue_quantity = $scope.rule.value[0].value;
                        else
                            $scope.rule.coupon_by_item_issue_quantity = 1;
                    }

                    if ($scope.model.couponBatchesList) {
                        $scope.rule.coupon_batch = itemByIndex($scope.model.couponBatchesList, $scope.rule.coupon_batch_code, 'code');
                    }

                    if (!$scope.rule.promotional_bonuses_starting_type)
                        $scope.rule.promotional_bonuses_starting_type = 'immediately';

                    if (!$scope.rule.promotional_bonuses_expire_type)
                        $scope.rule.promotional_bonuses_expire_type = 'date';

                    if (
                        [
                            'discount-percent-by-check',
                            'discount-amount-by-check',
                            'charge-percent-by-check',
                            'charge-amount-by-check',
                            'emission-coupon-by-check'
                        ].indexOf($scope.rule.action_type) !== -1
                    ) {
                        $scope.data.rule_depends = [
                            {id: 'amount', title: 'Amount'},
                            {id: 'bonuses-earned', title: 'depends type bonuses earned'},
                            {id: 'bonuses-on-account', title: 'depends type bonuses on account'},
                            {id: 'none', title: 'No dependence'}
                        ];
                    } else {
                        $scope.data.rule_depends = [
                            {id: 'amount', title: 'Amount'},
                            {id: 'quantity', title: 'Quantity'},
                            {id: 'none', title: 'No dependence'}
                        ];
                    }

                    if ($scope.data.action_types && $scope.rule.action_type) {
                        $scope.staff.boonTitle = $filter('translate')(itemByIndex($scope.data.action_types, $scope.rule.action_type).title);
                    }

                    if ($scope.rule.scheduled) {
                        if (!$scope.rule.time_from) {
                            $scope.rule.time_from = moment().startOf('day').utc().toDate();
                        } else {
                            var time_from = moment().set({
                                hour: $scope.rule.time_from.split(':')[0],
                                minute: $scope.rule.time_from.split(':')[1],
                                second: $scope.rule.time_from.split(':')[2]
                            });
                            $scope.rule.time_from = moment(time_from).utc().toDate();
                        }
                        if (!$scope.rule.time_to) {
                            $scope.rule.time_to = moment().endOf('day').utc().toDate();
                        } else {
                            var time_to = moment().set({
                                hour: $scope.rule.time_to.split(':')[0],
                                minute: $scope.rule.time_to.split(':')[1],
                                second: $scope.rule.time_to.split(':')[2]
                            });
                            $scope.rule.time_to = moment(time_to).utc().toDate();
                        }

                        if ($scope.rule.valid_after)
                            $scope.rule.valid_after = moment($scope.rule.valid_after).toDate();

                        if ($scope.rule.valid_before)
                            $scope.rule.valid_before = moment($scope.rule.valid_before).toDate();

                    } else {
                        $scope.rule.time_from = moment().startOf('day').utc().toDate();
                        $scope.rule.time_to = moment().endOf('day').utc().toDate();
                        // for (var i in $scope.data.week_days)
                        //     $scope.data.week_days[i].active = true;
                    }

                    if (!$scope.rule.promotional_bonuses_starting_date)
                        $scope.rule.promotional_bonuses_starting_date = moment().utc().toDate();

                    if (!$scope.rule.promotional_bonuses_starting_value)
                        $scope.rule.promotional_bonuses_starting_value = 1;

                    if (!$scope.rule.promotional_bonuses_expire_date)
                        $scope.rule.promotional_bonuses_expire_date = moment().add(1, 'month').utc().toDate();

                    if (!$scope.rule.promotional_bonuses_expire_value)
                        $scope.rule.promotional_bonuses_expire_value = 1;

                    if ($scope.rule.promotional_bonuses_starting_date)
                        $scope.rule.promotional_bonuses_starting_date = moment($scope.rule.promotional_bonuses_starting_date).toDate();

                    if ($scope.rule.promotional_bonuses_expire_date)
                        $scope.rule.promotional_bonuses_expire_date = moment($scope.rule.promotional_bonuses_expire_date).toDate();

                    if (!$scope.rule.coupon_do_not_add_to_wallet)
                        $scope.rule.coupon_do_not_add_to_wallet = 0;

                    if (!$scope.rule.count_bonuses_redeemed_amount)
                        $scope.rule.count_bonuses_redeemed_amount_brand = 1;

                    if ($scope.rule.count_bonuses_redeemed_amount == 1 || $scope.rule.count_bonuses_redeemed_amount == 0)
                        $scope.rule.count_bonuses_redeemed_amount_brand = 0;

                    if (angular.isArray($scope.rule.value) && $scope.rule.value.length > 0) {
                        $scope.staff.boonValue = $scope.rule.value[0].value;
                    } else {
                        $scope.staff.boonValue = 0;
                    }

                    if (!$scope.rule.depends_calc_period)
                        $scope.rule.depends_calc_period = 'all';

                    if (!$scope.rule.applicable_api_scope)
                        $scope.rule.applicable_api_scope = 'all';

                    if (!$scope.isRuleDiscountSelect() && !$scope.rule.charge_type) {
                        $scope.rule.charge_type = 'regular-bonuses';
                    }

                    $scope.model.isRuleEdit = true;
                    previousRule = angular.copy($scope.rule);
                })
            }
        };

        /**
         * Save rule
         */
        $scope.submitRuleForm = function (form) {

            var post_data = angular.copy($scope.rule),
                errors = false;

            post_data.automatic = parseInt(post_data.automatic);

            if (!$scope.rule.charge_type && !$scope.isRuleDiscountSelect()) {
                $scope.rule.charge_type = 'regular-bonuses';
            }

            if (!post_data.time_from || !post_data.time_to) {
                delete post_data.time_from;
                delete post_data.time_to;
            } else if (post_data.time_from && post_data.time_to) {
                post_data.time_from = moment(post_data.time_from).format('HH:mm:ss');
                post_data.time_to = moment(post_data.time_to).format('HH:mm:ss');
            }

            if (!post_data.valid_after || !post_data.valid_before) {
                delete post_data.valid_after;
                delete post_data.valid_before;
            } else if (post_data.valid_after && post_data.valid_before) {
                post_data.valid_after = moment(post_data.valid_after).format('YYYY-MM-DD');
                post_data.valid_before = moment(post_data.valid_before).format('YYYY-MM-DD');
            }

            if (post_data.promotional_bonuses_expire_date) {
                post_data.promotional_bonuses_expire_date = moment(post_data.promotional_bonuses_expire_date).format('YYYY-MM-DD');
            }

            if (post_data.promotional_bonuses_starting_date) {
                post_data.promotional_bonuses_starting_date = moment(post_data.promotional_bonuses_starting_date).format('YYYY-MM-DD');
            }

            if (post_data.automatic === 2) {
                post_data.combine = 0;
            }

            // Set week_days
            // $scope.rule.week_days = [];
            // angular.forEach($scope.data.week_days, function(value, key) {
            //     if (value.active)
            //         $scope.rule.week_days.push(key);
            // });
            // post_data.week_days = $scope.rule.week_days;

            if (post_data.special_account) {
                post_data.special_account_id = $scope.rule.special_account.id;
                delete post_data.special_account;
            }

            // Convert UI dictionary to API array
            function _makeTagArray(d, c) {
                var result = [];
                if (d)
                    d.forEach(function (item) {
                        if (c && result.indexOf('item.title') === -1)
                            result.push(item.title);
                        else
                            result.push(item.code);
                    });
                return result.filter(function (value, index, self) {
                    return self.indexOf(value) === index;
                });
            }

            // Set products arrays
            if ($scope.isProductAction()) {
                post_data.included_item_categories = _makeTagArray($scope.model.included_item_categories, true);
                post_data.included_items = _makeTagArray($scope.model.included_items, false);
                post_data.excluded_item_categories = _makeTagArray($scope.model.excluded_item_categories, true);
                post_data.excluded_items = _makeTagArray($scope.model.excluded_items, false);

                if (post_data.use_alternative_dependencies_by_items) {
                    post_data.depends_included_item_categories = _makeTagArray($scope.model.depends_included_item_categories, true);
                    post_data.depends_included_items = _makeTagArray($scope.model.depends_included_items, false);
                    post_data.depends_excluded_item_categories = _makeTagArray($scope.model.depends_excluded_item_categories, true);
                    post_data.depends_excluded_items = _makeTagArray($scope.model.depends_excluded_items, false);
                }
            }

            // Default threshold
            if ($scope.rule.depends_type === 'none') {
                delete post_data.depends_calc_period;
                post_data.value = [
                    {
                        value: $scope.staff.boonValue,
                        threshold: 0
                    }];
            } else if ($scope.rule.depends_type === 'amount' || $scope.rule.depends_type === 'quantity') {
                if (angular.isArray($scope.rule.value) && $scope.rule.value.length === 0)
                    $scope.errors.rule_value = true;
            }

            if (post_data.action_type === 'emission-coupon-by-item')
                post_data.value = [
                    {
                        value: parseInt($scope.rule.coupon_by_item_issue_quantity),
                        threshold: post_data.value[0].threshold
                    }];

            if (post_data.action_type === 'emission-coupon-by-check')
                post_data.value = [
                    {
                        value: 1,
                        threshold: post_data.value[0].threshold
                    }];

            // Reset limit
            if (!$scope.staff.is_limit_max_count)
                post_data.items_limit_max = 0;

            if (!$scope.staff.is_limit_min_count)
                post_data.items_limit_min = 0;

            if ($scope.staff.is_limit_max_count &&
                $scope.staff.is_limit_min_count &&
                post_data.items_limit_min > post_data.items_limit_max) {
                form.items_limit_min.$invalid = form.items_limit_min.$dirty = true;
                form.items_limit_max.$invalid = form.items_limit_max.$dirty = true;
                NotifyService.Warning('Please check if all data are correct.', false);
                return;
            }

            if (post_data.coupon_batch) {
                post_data.coupon_batch_code = post_data.coupon_batch.code;
            }

            if (post_data.count_bonuses_redeemed_amount_brand) {
                post_data.count_bonuses_redeemed_amount = null;
            }

            delete post_data.count_bonuses_redeemed_amount_brand;

            // // Reset default
            // if (!$scope.isRuleDiscountSelect()) {
            //     post_data.charge_type = 'regular-bonuses';
            // }

            function _updateRule(response) {

                LoyaltyService.LoyaltyRules($routeParams.loyalty_id, function (success, data) {
                    if (success) {
                        // updateItemInList($rootScope.LOYALTY_RULES[$routeParams.loyalty_id], response);
                        $scope.data.loyaltyRules = data;
                        $scope.model.isRuleEdit = false;
                        NotifyService.Success('', false);
                    }

                });

            }

            if (isFormValid(form) && !$scope.errors.rule_value) {
                block_edit.start();
                post_data.coupon_by_item_issue_quantity = parseInt(post_data.coupon_by_item_issue_quantity);
                if ($scope.rule.id) {
                    LoyaltyService.ChangeLoyaltyRule($scope.rule.loyalty_id, $scope.rule.id, post_data, function (success, response) {
                        if (success)
                            _updateRule(response);

                        block_edit.stop();
                    });
                } else {
                    LoyaltyService.CreateLoyaltyRule($routeParams.loyalty_id, post_data, function (success, response) {
                        if (success)
                            _updateRule(response);

                        block_edit.stop();
                    });
                }
            } else {
                if ($scope.errors.rule_value) {
                    var tf = document.getElementsByName('treshhold_error')[0];
                    $('html,body').animate({scrollTop: angular.element(tf).offset().top - 200}, 'fast');
                }
            }
        };

        $scope.goodsTagHandler = function (code) {
            console.log('goodsTagHandler', code);
            return {title: '', code: code};
        };

        $scope.categoryTagHandler = function (title) {
            return {title: title};
        };

        // $scope.couponsBatchesTagHandler = function (code) {
        //     return { title: '', code: code };
        // }

        function _isComplicatedPaste(item) {
            return $scope.separatorList.reduce(function (base, s) {
                return base.replace(new RegExp(s, 'gi'), ',');
            }, item).indexOf(',') !== -1;
        }

        function _transformPaste(value) {
            if (!value || value.length === 0 || !_isComplicatedPaste(value)) return false;

            var newListItems = $scope.separatorList.reduce(function (base, s) {
                return base.replace(new RegExp(s, 'gi'), ',');
            }, value).split(',');

            var values_list = (value || '').split(
                new RegExp([',', ';', '\t', '\n', ' '].join('|'), 'g')
            ).map(function (value) {
                return value.trim();
            }).filter(function (value) {
                return value.length > 0;
            });

            return ((newListItems || []).map(function (el) {
                var newEl = {isTag: true, title: ''};
                newEl.code = el.trim();
                return newEl;
            }).filter(function (el) {
                return el.code !== '';
            }));
        }

        $scope.pasteTagHandler = function (values) {
            var separators = [',', '\n'],
                separator,
                values_list;

            for (var i in separators)
                if (values && values.indexOf(separators[i]) > 0)
                    separator = separators[i];

            if (separator)
                values_list = values.replace(' ', '').split(separator);
            else
                values_list = values.split(' ');

            if (values_list && values_list.length > 0) {
                values_list = values_list.filter(function (elem, index, self) {
                    return index == self.indexOf(elem);
                });

                for (var i in values_list) {
                    if (!this.ngModel.$modelValue)
                        this.ngModel.$modelValue = [];
                    if (values_list[i]) {
                        this.ngModel.$modelValue.push({title: '', code: values_list[i]});
                    }
                }
            }
        };

        $scope.pasteCategoryTagHandler = function (values) {
            var separators = [',', '\n'],
                separator,
                values_list;

            for (var i in separators)
                if (values && values.indexOf(separators[i]) > 0)
                    separator = separators[i];

            if (separator)
                values_list = values.replace(' ', '').split(separator);
            else
                values_list = values.split(' ');

            if (values_list && values_list.length > 0) {
                values_list = values_list.filter(function (elem, index, self) {
                    return index == self.indexOf(elem);
                });

                for (var i in values_list) {
                    if (!this.ngModel.$modelValue)
                        this.ngModel.$modelValue = [];
                    if (values_list[i]) {
                        this.ngModel.$modelValue.push({title: values_list[i]});
                    }
                }
            }
        };
        // Исключить товары
        // $scope.pasteTagHandler = function (value) {
        //     console.log('pasteTagHandler', value);
        //     if (!value) return;
        //     var result = _transformPaste(value);
        //     console.log('result', result);
        //     var keys = this.ngModel.$$attr.ngModel.split('.');
        //     if (result)
        //         if (!!$scope[keys[0]][keys[1]]) {
        //             $scope[keys[0]][keys[1]] = [].concat($scope[keys[0]][keys[1]], result);
        //         } else {
        //             $scope[keys[0]][keys[1]] = result;
        //         }
        //     // $scope[keys[0]][keys[1]] = $scope[keys[0]][keys[1]] ? [...$scope[keys[0]][keys[1]], ...result] : result;
        // };

        /**
         * Received when user change filter
         * @param id - Loyalty or POS id
         */
        $scope.onFilterChange = function (id) {
            $scope.rule.pos_id = id;
            if ($scope.rule.pos_id && $scope.rule.pos_id.indexOf('POS-') === 0) {
                $rootScope.ENV.LastPos = getPOSId($scope.rule.pos_id);
                $rootScope.storeENV();
            }
        };

        /**
         * End rule edit
         */
        $scope.onRuleCancelEdit = function () {
            $scope.model.isRuleEdit = false;
        };

        /**
         * Display rule type
         */

        /**
         * Received event when change action
         */
        $scope.onRuleTypeSelect = function () {

            if ($scope.rule.depends_type == 'bonuses-on-account') {
                $scope.rule.depends_calc_period = 'all';
            } else if ($scope.rule.depends_type == 'bonuses-earned') {

            }

            if ($scope.rule.action_type === 'emission-coupon-by-item' || $scope.rule.action_type === 'emission-coupon-by-check')
                $scope.rule.value = [{'value': 0.00, 'threshold': 1}];
            else
                $scope.rule.value = [{'value': 0.00, 'threshold': 0}];

            if (
                [
                    'discount-percent-by-check',
                    'discount-amount-by-check',
                    'charge-percent-by-check',
                    'charge-amount-by-check',
                    'emission-coupon-by-check'
                ].indexOf($scope.rule.action_type) !== -1
            ) {
                $scope.data.rule_depends = [
                    {id: 'amount', title: 'Amount'},
                    {id: 'bonuses-earned', title: 'depends type bonuses earned'},
                    {id: 'bonuses-on-account', title: 'depends type bonuses on account'},
                    {id: 'none', title: 'No dependence'}
                ];
            } else {
                $scope.data.rule_depends = [
                    {id: 'amount', title: 'Amount'},
                    {id: 'quantity', title: 'Quantity'},
                    {id: 'none', title: 'No dependence'}
                ];
            }

            if ($scope.rule.action_type == 'emission-coupon-by-item')
                $scope.rule.coupon_by_item_issue_quantity = 1;

            $scope.staff.boonTitle = $filter('translate')(itemByIndex($scope.data.action_types, $scope.rule.action_type).title);

            if (!$scope.isRuleDiscountSelect()) {
                $scope.rule.charge_type = 'regular-bonuses';
            }
        };

        // ==== UI flags ====

        $scope.isNeedLimit = function () {
            var a = ['discount-percent-by-item', 'discount-amount-by-item', 'special-price-by-item', 'charge-percent-by-item', 'charge-amount-by-item', 'emission-coupon-by-item']
            return a.indexOf($scope.rule.action_type) > -1;
        };

        $scope.isRuleDiscountSelect = function () {
            var a = [
                'discount-percent-by-item',
                'discount-amount-by-item',
                'special-price-by-item',
                'discount-percent-by-check',
                'discount-amount-by-check',
                'emission-coupon-by-item',
                'emission-coupon-by-check'];
            return a.indexOf($scope.rule.action_type) > -1;
        };

        $scope.isProductAction = function () {
            var a = [
                'discount-percent-by-item',
                'discount-amount-by-item',
                'special-price-by-item',
                'charge-percent-by-item',
                'charge-amount-by-item',
                'emission-coupon-by-item'];
            return a.indexOf($scope.rule.action_type) > -1;
        };

        /**
         * Delete threshold from table values
         * @param value
         */
        $scope.ruleValueDeleteClick = function (value) {
            $scope.rule.value.forEach(function (item) {
                if (item == value) {
                    $scope.rule.value.splice($scope.rule.value.indexOf(value), 1);
                }
            });
        };

        $scope.ruleValueEditClick = function (value) {
            $scope.isRuleValueEdit = true;
            $scope.editingRule = value;
            $scope.backupRule = angular.copy(value);
        };

        $scope.onSaveRuleValue = function (saveItem, index, form) {
            var rule_values_error = false;

            for (var i in form.$error.required) {
                if (!rule_values_error && /(rule_threshold_|rule_value_)/.test(form.$error.required[i].$name)) {
                    rule_values_error = true;
                }
            }

            if (saveItem && !rule_values_error) {
                var existThreshold = false;

                $scope.rule.value.forEach(function (item) {
                    if (!(item.$$hashKey == $scope.editingRule.$$hashKey) && (item.threshold == $scope.editingRule.threshold)) existThreshold = true;
                });

                if (existThreshold) {
                    NotifyService.Warning('Threshold with same value exists!', false);
                } else {
                    // OK, store
                    $scope.isRuleValueEdit = false;
                    $scope.isRuleValueAdd = false;
                    $scope.editingRule = null;
                    $scope.backupRule = null;

                    var orderBy = $filter('orderBy');
                    $scope.rule.value = orderBy($scope.rule.value, 'threshold', false);
                }
            } else {
                if (form['rule_value_' + index])
                    form['rule_value_' + index].$dirty = true;
                if (form['rule_threshold_' + index])
                    form['rule_threshold_' + index].$dirty = true;
            }
        };

        /**
         * Cancel rule edit
         */
        $scope.onCancelRuleValue = function () {
            $scope.isRuleValueEdit = false;
            if ($scope.isRuleValueAdd) {
                if (!($scope.rule.action_type == 'emission-coupon-by-check' || $scope.rule.action_type == 'emission-coupon-by-item'))
                    $scope.ruleValueDeleteClick($scope.editingRule);
            } else {
                $scope.editingRule.value = $scope.backupRule.value;
                $scope.editingRule.thresholds = $scope.backupRule.thresholds;
                $scope.backupRule = null;
            }
            $scope.isRuleValueAdd = false;
        };

        /**
         * Add rule to loyalty
         */
        $scope.onAddRuleThreshold = function () {
            $scope.newrule = {
                value: 0,
                threshold: 0
            };
            $scope.isRuleValueAdd = true;
            $scope.isRuleValueEdit = true;
            $scope.rule.value.push($scope.newrule);
            console.info('Store', $scope.rule);
            $scope.editingRule = $scope.newrule;
        };

        $scope.isRuleValueCurrent = function (item) {
            return $scope.isRuleValueEdit && (item.$$hashKey == $scope.editingRule.$$hashKey);
        };

        // $scope.$watch('form.$dirty', function(newValues, oldValues){
        //
        //     // if ($scope.loyaltyState.isLoading)
        //
        // });

        $scope.onLimitMaxEnable = function () {
            if ($scope.staff.is_limit_max_count && $scope.rule.items_limit_max < $scope.rule.items_limit_min) {
                $scope.rule.items_limit_max = $scope.rule.items_limit_min;
            }
        };

        $scope.onLimitMinEnable = function () {
            if ($scope.staff.is_limit_min_count && $scope.rule.items_limit_max < $scope.rule.items_limit_min) {
                $scope.rule.items_limit_min = $scope.rule.items_limit_max;
            }
        };

        // *********************************************************************************************
        //  EDIT ADDITIONAL SETTINGS
        // *********************************************************************************************

        $scope.onBirthdayGiftSelect = function () {
            if ($scope.additional.birthdate_gift == 'promotional-bonuses' && !$scope.additional.birthdate_bonuses_expire_type)
                $scope.additional.birthdate_bonuses_expire_type = 'date';
        };

        function getAdditionalSettings() {
            $scope.additional = {
                birthdate_bonuses_expire_type: 'date',
                new_customer_access_type: 'full-bonuses-access',
                show_customers_questionnaire: 'do-not-show',
                transaction_notification_type: 'smart'
            };

            block_edit.start();
            LoyaltyService.LoyaltySettings($routeParams.loyalty_id, function (success, data) {
                if (success) {
                    $scope.additional = $rootScope.LOYALTY_SETTINGS[$routeParams.loyalty_id];

                    $scope.state.dontUseBonuses = (parseInt($scope.additional.bonus_payment_limit) == 0);

                    if (!$scope.additional.birthdate_bonuses_currency)
                        $scope.additional.birthdate_bonuses_currency = $rootScope.ENV.business.currency;

                    $scope.multilang.initStrings($scope.additional, ['birthdate_message', 'message_footer']);

                    TerminalService.All(function (success, data) {
                        if (success) {
                            $scope.loyaltyTerminals = [];
                            $rootScope.TERMINALS.forEach(function (item) {
                                if ($routeParams.loyalty_id == item.loyalty_id &&
                                    (item.active == 1 || item.id == $scope.additional.birthdate_terminal_id)) {
                                    $scope.loyaltyTerminals.push(item);
                                }
                            });
                            console.log('TERMINALS', $scope.loyaltyTerminals);
                        }
                        block_edit.stop();
                    });
                } else {
                    block_edit.stop();
                }
            });
        }

        function getCurrenciesList() {
            if (!$scope.data.currenciesList || $scope.data.currenciesList.length === 0)
                BusinessService.CurrencyList(null, function (success, response) {
                    if (success)
                        $scope.data.currenciesList = response;
                    if ($scope.data.currenciesList.indexOf('EUR') == -1)
                        $scope.data.currenciesList.push('EUR');

                    if ($scope.data.currenciesList.indexOf('USD') == -1)
                        $scope.data.currenciesList.push('USD');
                });

        }

        $scope.onSaveAdditionalSettings = function (form) {
            var post_data = angular.copy($scope.additional);
            if ($scope.state.dontUseBonuses) {
                post_data.bonus_payment_limit = 0;
            }
            if (isFormValid(form)) {
                block_edit.start();
                LoyaltyService.LoyaltySettingsEdit($routeParams.loyalty_id, post_data, function (success, data) {
                    if (success) {
                        NotifyService.Success('', false);
                    }
                    block_edit.stop();
                });
            }
        };

        $scope.onSaveCardCategoriesSettings = function (form) {
            var post_data = angular.copy($scope.card_categories_settings);
            if (isFormValid(form)) {
                block_edit.start();
                LoyaltyService.SaveCardCategoriesSettings($routeParams.loyalty_id, post_data, function (success, data) {
                    if (success) {
                        NotifyService.Success('', false);
                    }
                    block_edit.stop();
                });
            }
        };

        /**
         * Click onBirthdateCongratulation
         */
        $scope.onBirthdateCongratulation = function () {
            console.info('birthdate_congratulation', angular.toJson($scope.additional.birthdate_message));
            if ($scope.additional.birthdate_congratulation &&
                (!$scope.additional.birthdate_message || Object.keys($scope.additional.birthdate_message).length === 0) ||
                angular.toJson($scope.additional.birthdate_message) === '{}') {
                $scope.additional.birthdate_message = {};
                for (var i in LANGS) {
                    var t = $translate.instant('TEXT_BIRTHDAY_GREETING_TEMPLATE', {}, undefined, i, undefined);
                    $scope.additional.birthdate_message[i] = '{{username}}, ' + t + ' ' + $scope.model.title + '.';
                }
            }
        };

        $rootScope.$watch('TIMEZONES[LANG]', function (newValue, oldValue, scope) {
            if (newValue) {
                $scope.data.timezonesList = angular.copy($rootScope.TIMEZONES[$rootScope.LANG]);

                // var index;
                // for (var i in $scope.data.timezonesList)
                //     if ($scope.data.timezonesList[i].id === 'Etc/UTC')
                //         index = i;

                // if (!index)
                //     $scope.data.timezonesList.push({id: 'Etc/UTC', title: 'Etc/UTC', offset: '+00:00'})
            }
        }, true);

        function _isComplicated(item) {
            return $scope.separatorList.reduce(function (base, s) {
                return base.replace(new RegExp(s, 'gi'), ',');
            }, item).indexOf(',') !== -1;
        }

        function _transform(value) {
            if (!value || value.length === 0) return value;

            value.map(function (item, index) {
                if (_isComplicated(item.code)) {
                    var newListItems = $scope.separatorList.reduce(function (base, s) {
                        return base.replace(new RegExp(s, 'gi'), ',');
                    }, item.code).split(',');

                    value.splice(index, 1, [].concat((newListItems.map(function (el) {
                            var newEl = {isTag: true, title: ''};
                            newEl.code = el.trim();
                            return newEl;
                        }).filter(function (el) {
                            return el.code !== '';
                        })))
                    );

                    return;
                }
            });
            return value;
        }

        $scope.$watch('model.included_items', function (newValue, oldValue, scope) {
            if (!oldValue || newValue.length > oldValue.length)
                $scope.model.included_items = _transform(newValue);
        }, true);

        $scope.$watch('model.excluded_items', function (newValue, oldValue, scope) {
            if (!oldValue || oldValue && newValue.length > oldValue.length)
                $scope.model.excluded_items = _transform(newValue);
        }, true);

        // $scope.$watch('data.loyaltyRules', function (newValue, oldValue, scope) {
        //     if (oldValue)
        //         $scope.state.rulesOrderChanged = true;
        // }, true);

        // $scope.$watch('data.categoryRules', function (newValue, oldValue, scope) {
        //     if (oldValue)
        //         $scope.state.rulesCategoryOrderChanged = true;
        // }, true);

        // *********************************************************************************************
        //  EDIT REFERRAL PROGRAM
        // *********************************************************************************************

        function getReferralProgram() {
            $scope.referral_program = {
                referrer_type: 'all-users',
                referral_type: 'not-in-business-customers',
                referral_reward_type: 'none',
                referral_reward_promotional_bonuses_expire_type: 'day',
                referrer_reward_grant_type: 'none',
                referrer_reward_grant_period_type: 'day',
                referrer_reward_type: 'regular-bonuses',
                referrer_reward_value_type: 'check-percentage',
                referrer_reward_promotional_bonuses_expire_type: 'day'
            };

            $scope.isReferralLevelValueEdit = false;
            $scope.isReferralLevelValueAdd = false;
            $scope.editingReferralLevel = null;
            $scope.backupReferralLevel = null;

            block_edit.start();
            getCurrenciesList();

            LoyaltyService.LoyaltyReferralProgram($routeParams.loyalty_id, function (success, data) {
                if (success) {
                    $scope.referral_program = $rootScope.LOYALTY_REFERRAL_PROGRAM[$routeParams.loyalty_id];

                    if (!$scope.referral_program.referral_reward_bonuses_currency)
                        $scope.referral_program.referral_reward_bonuses_currency = $rootScope.ENV.business.currency;

                    if (!$scope.referral_program.referral_reward_promotional_bonuses_expire_type)
                        $scope.referral_program.referral_reward_promotional_bonuses_expire_type = 'date';

                    if (!$scope.referral_program.referrer_reward_promotional_bonuses_expire_type)
                        $scope.referral_program.referrer_reward_promotional_bonuses_expire_type = 'date';

                    if (!$scope.referral_program.referrer_reward_promotional_bonuses_starting_type)
                        $scope.referral_program.referrer_reward_promotional_bonuses_starting_type = 'date';

                    if (!$scope.referral_program.referral_reward_promotional_bonuses_starting_type)
                        $scope.referral_program.referral_reward_promotional_bonuses_starting_type = 'date';

                    if (!$scope.referral_program.referral_reward_promotional_bonuses_expire_date)
                        $scope.referral_program.referral_reward_promotional_bonuses_expire_date = moment().add(1, 'month').utc().toDate();

                    if (!$scope.referral_program.referral_reward_promotional_bonuses_starting_date)
                        $scope.referral_program.referral_reward_promotional_bonuses_starting_date = moment().add(1, 'month').utc().toDate();

                    if (!$scope.referral_program.referral_reward_promotional_bonuses_expire_value ||
                        $scope.referral_program.referral_reward_promotional_bonuses_expire_value === 0)
                        $scope.referral_program.referral_reward_promotional_bonuses_expire_value = 1;

                    if (!$scope.referral_program.referrer_reward_grant_checks_number ||
                        $scope.referral_program.referrer_reward_grant_checks_number === 0)
                        $scope.referral_program.referrer_reward_grant_checks_number = 1;

                    if (!$scope.referral_program.referrer_reward_grant_period_type)
                        $scope.referral_program.referrer_reward_grant_period_type = 'day';

                    if (!$scope.referral_program.referrer_reward_grant_period_value ||
                        $scope.referral_program.referrer_reward_grant_period_value === 0)
                        $scope.referral_program.referrer_reward_grant_period_value = 1;

                    if (!$scope.referral_program.referrer_reward_promotional_bonuses_starting_date)
                        $scope.referral_program.referrer_reward_promotional_bonuses_starting_date = moment().add(1, 'month').utc().toDate();

                    if (!$scope.referral_program.referrer_reward_promotional_bonuses_expire_date)
                        $scope.referral_program.referrer_reward_promotional_bonuses_expire_date = moment().add(1, 'month').utc().toDate();

                    if (!$scope.referral_program.referrer_reward_promotional_bonuses_expire_type)
                        $scope.referral_program.referrer_reward_promotional_bonuses_expire_type = 'date';

                    if (!$scope.referral_program.referrer_reward_promotional_bonuses_expire_value ||
                        $scope.referral_program.referrer_reward_promotional_bonuses_expire_value === 0)
                        $scope.referral_program.referrer_reward_promotional_bonuses_expire_value = 1;

                    if (!$scope.referral_program.referrer_reward_value_type)
                        $scope.referral_program.referrer_reward_value_type = 'check-percentage';

                    if (!$scope.referral_program.levels) {
                        $scope.referral_program.levels = [];
                    } else {
                        $scope.referral_program.levels.map(function (level) {
                            if (!level.value) {
                                level.value = 0;
                            }
                            return level.value;
                        });
                        $scope.referral_program.levels.sort(compareReferralLevels);
                    }

                    $scope.multilang.initStrings($scope.referral_program, ['public_title', 'public_description', 'referral_public_description', 'referral_public_title', 'referrer_public_description', 'referrer_public_title']);

                    $scope.referral_program.allow_referral_public_description = !!$scope.referral_program.referral_public_description;
                    $scope.referral_program.allow_referrer_public_description = !!$scope.referral_program.referrer_public_description;
                    $scope.referral_program.allow_referral_logo = !!$scope.referral_program.referral_logo;
                    $scope.referral_program.allow_referrer_logo = !!$scope.referral_program.referrer_logo;

                    console.info('Referral Program Settings', $scope.referral_program);

                    block_edit.stop();
                } else {
                    block_edit.stop();
                }
            });
        }

        $scope.openModalEditReferralLevels = function (level, fromEdit) {
            $uibModal.open({
                animation: true,
                keyboard: true,
                backdrop: 'static',
                templateUrl: 'app/pages/loyalty/modals/modal.add-referral-levels.html',
                controllerAs: 'popup',
                windowTopClass: 'modal-center',
                controller: function ($uibModalInstance) {
                    var popup = this;
                    popup.level = angular.copy(level);
                    popup.level.value_depends_matrix = level.value_depends_matrix || [];
                    popup.value_depends_type = ['none', 'level-referrals-number', 'level-referrals-sale-number'];
                    popup.isLevelValueEdit = false;
                    popup.isLevelValueAdd = true;
                    popup.editingLevel = null;
                    popup.backupLevel = null;

                    popup.levelValueDeleteClick = function (value) {
                        popup.level.value_depends_matrix.forEach(function (item) {
                            if (item == value) {
                                popup.level.value_depends_matrix.splice(popup.level.value_depends_matrix.indexOf(value), 1);
                            }
                        });
                    };

                    popup.onLevelValueEditClick = function (value) {
                        popup.isLevelValueEdit = true;
                        popup.editingLevel = value;
                        popup.backupLevel = angular.copy(value);
                    };

                    popup.onSaveLevelValue = function (saveItem, index, form) {
                        if (saveItem && form.$valid) {
                            var existThreshold = false;

                            popup.level.value_depends_matrix.forEach(function (item) {
                                if (!(item.$$hashKey == popup.editingLevel.$$hashKey) &&
                                    (item.threshold == popup.editingLevel.threshold)) existThreshold = true;
                            });

                            if (existThreshold) {
                                NotifyService.Warning('Threshold with same value exists!', false);
                            } else {
                                // OK, store
                                popup.isLevelValueEdit = false;
                                popup.isLevelValueAdd = false;
                                popup.editingLevel = null;
                                popup.backupLevel = null;

                                var orderBy = $filter('orderBy');
                                popup.level.value_depends_matrix = orderBy(popup.level.value_depends_matrix, 'threshold', false);
                            }
                        } else {
                            if (form['sublevel_value_' + index])
                                form['sublevel_value_' + index].$dirty = true;
                            if (form['sublevel_threshold_' + index])
                                form['sublevel_threshold_' + index].$dirty = true;
                        }
                    };

                    popup.onCancelLevelValue = function () {
                        popup.isLevelValueEdit = false;
                        if (popup.isLevelValueAdd) {
                            popup.levelValueDeleteClick(popup.editingLevel);
                        } else {
                            popup.editingLevel.value = popup.backupLevel.value;
                            popup.editingLevel.thresholds = popup.backupLevel.thresholds;
                            popup.backupLevel = null;
                        }
                        popup.isLevelValueAdd = false;
                    };

                    popup.onAddLevelThreshold = function () {
                        var threshold = 0;
                        if (popup.level.value_depends_matrix && popup.level.value_depends_matrix.length > 0) {
                            popup.level.value_depends_matrix.map(function (res) {
                                if (res.threshold > threshold) {
                                    threshold = res.threshold;
                                }
                            });
                            threshold = threshold + 1;
                        } else {
                            threshold = 1;
                        }
                        popup.newLevel = {
                            value: 0,
                            threshold: threshold
                        };
                        popup.isLevelValueAdd = true;
                        popup.isLevelValueEdit = true;
                        popup.level.value_depends_matrix.push(popup.newLevel);
                        console.info('Store', popup.level.value_depends_matrix);
                        popup.editingLevel = popup.newLevel;
                    };

                    popup.isLevelValueCurrent = function (item) {
                        return popup.isLevelValueEdit && (item.$$hashKey == popup.editingLevel.$$hashKey);
                    };

                    popup.selectValueDependsType = function (model) {
                        if (model == 'none') {
                            popup.level.value_depends_matrix = [];
                        }
                        popup.level.value_depends_type = model;
                    };

                    popup.saveLevels = function () {
                        level.value_depends_type = popup.level.value_depends_type;
                        if (popup.level.value_depends_type == 'none') {
                            level.value_depends_matrix = [];
                            level.value = popup.level.value;
                        } else {
                            level.value_depends_matrix = popup.level.value_depends_matrix || [];
                            level.value = popup.level.value = 0;
                        }
                        $uibModalInstance.close();
                    };

                    popup.closeModal = function (exit) {
                        if (!fromEdit) {
                            $scope.onReferralLevelValueDeleteClick(level);
                        }
                        $uibModalInstance.close();
                    };
                }
            });
        };

        /**
         * Raised when user select local file
         * @param evt
         */
        $scope.handleReferralFileSelect = function (evt) {
            var file = evt.currentTarget.files[0],
                reader = new FileReader();

            reader.onload = function (e) {
                var img = new Image();

                img.onload = function () {
                    var canvas = document.getElementById('file-canvas-referral'),
                        ctx = canvas.getContext('2d'),
                        width = img.width,
                        height = img.height,
                        maxAllowedSize = 2 * 1024 * 1024;

                    if (file.size > maxAllowedSize) {
                        const scalingFactor = Math.sqrt(maxAllowedSize / file.size);
                        width *= scalingFactor;
                        height *= scalingFactor;
                    }

                    canvas.width = width;
                    canvas.height = height;
                    ctx.drawImage(img, 0, 0, width, height);

                    var quality = 1,
                        resizedImageDataUrl;

                    do {
                        quality -= 0.1;
                        resizedImageDataUrl = canvas.toDataURL('image/jpeg', quality);
                    } while (resizedImageDataUrl.length > maxAllowedSize && quality > 0.1);

                    $scope.$apply(function () {
                        $scope.referral.image.cropped = '';
                        $scope.referral.image.loading = false;
                        $scope.referral.image.new = true;
                        $scope.referral.image.src = resizedImageDataUrl;
                    });
                };
                img.src = e.target.result;
            };

            reader.readAsDataURL(file);
            $scope.referral.image.loading = true;
        };
        //angular.element('#loyaltyPicture').on('change', $scope.handleFileSelect);

        $scope.initImgReferralCrop = function () {
            var file = angular.element(document.getElementById('referralLogo'));
            file.on('change', $scope.handleReferralFileSelect);
        };

        $scope.deleteReferralPhoto = function () {
            if ($scope.referral.image.new) {
                $scope.referral.image.new = false;
                $scope.referral.image.src = '';
            } else if ($scope.referral_program.referral_logo && $scope.referral_program.referral_logo.url) {
                delete $scope.referral_program.referral_logo;
                $scope.referral.image.delete = true;
            }
        };

        $scope.cropReferralPhoto = function () {
            $uibModal.open({
                animation: false,
                keyboard: true,
                backdrop: 'static',
                templateUrl: 'app/templates/modal.crop-image.html',
                controllerAs: 'popup',
                windowTopClass: 'modal-full',
                controller: function ($uibModalInstance) {
                    var popup_crop = this;
                    popup_crop.image = angular.copy($scope.referral.image);

                    popup_crop.onCancelClick = function () {
                        $uibModalInstance.close();
                    }

                    popup_crop.onCropImage = function () {
                        $scope.referral.image = angular.copy(popup_crop.image);
                        $uibModalInstance.close();
                    }
                }
            })
        }

        $scope.handleReferrerFileSelect = function (evt) {
            var file = evt.currentTarget.files[0],
                reader = new FileReader();

            reader.onload = function (e) {
                var img = new Image();

                img.onload = function () {
                    var canvas = document.getElementById('file-canvas-referrer'),
                        ctx = canvas.getContext('2d'),
                        width = img.width,
                        height = img.height,
                        maxAllowedSize = 2 * 1024 * 1024;

                    if (file.size > maxAllowedSize) {
                        const scalingFactor = Math.sqrt(maxAllowedSize / file.size);
                        width *= scalingFactor;
                        height *= scalingFactor;
                    }

                    canvas.width = width;
                    canvas.height = height;
                    ctx.drawImage(img, 0, 0, width, height);

                    var quality = 1,
                        resizedImageDataUrl;

                    do {
                        quality -= 0.1;
                        resizedImageDataUrl = canvas.toDataURL('image/jpeg', quality);
                    } while (resizedImageDataUrl.length > maxAllowedSize && quality > 0.1);

                    $scope.$apply(function () {
                        $scope.referrer.image.cropped = '';
                        $scope.referrer.image.loading = false;
                        $scope.referrer.image.new = true;
                        $scope.referrer.image.src = resizedImageDataUrl;
                    });
                };
                img.src = e.target.result;
            };

            reader.readAsDataURL(file);
            $scope.referrer.image.loading = true;
        };

        $scope.initImgReferrerCrop = function () {
            var file = angular.element(document.getElementById('referrerLogo'));
            file.on('change', $scope.handleReferrerFileSelect);
        };

        $scope.deleteReferrerPhoto = function () {
            if ($scope.referrer.image.new) {
                $scope.referrer.image.new = false;
                $scope.referrer.image.src = '';
            } else if ($scope.referral_program.referrer_logo && $scope.referral_program.referrer_logo.url) {
                delete $scope.referral_program.referrer_logo;
                $scope.referrer.image.delete = true;
            }
        };

        $scope.cropReferrerPhoto = function () {
            $uibModal.open({
                animation: false,
                keyboard: true,
                backdrop: 'static',
                templateUrl: 'app/templates/modal.crop-image.html',
                controllerAs: 'popup',
                windowTopClass: 'modal-full',
                controller: function ($uibModalInstance) {
                    var popup_crop = this;
                    popup_crop.image = angular.copy($scope.referrer.image);

                    popup_crop.onCancelClick = function () {
                        $uibModalInstance.close();
                    }

                    popup_crop.onCropImage = function () {
                        $scope.referrer.image = angular.copy(popup_crop.image);
                        $uibModalInstance.close();
                    }
                }
            })
        };

        $scope.onSaveReferralProgram = function (form) {
            var post_data = angular.copy($scope.referral_program);

            if (!post_data.allow_referral_public_description) {
                post_data.referral_public_description = null;
                post_data.referral_public_title = null;
            }

            if (!post_data.allow_referrer_public_description) {
                post_data.referrer_public_description = null;
                post_data.referrer_public_title = null;
            }

            delete post_data.allow_referral_public_description;
            delete post_data.allow_referral_logo;

            delete post_data.allow_referrer_public_description;
            delete post_data.allow_referrer_logo;

            if (isFormValid(form)) {
                block_edit.start();
                LoyaltyService.LoyaltyReferralProgramEdit($routeParams.loyalty_id, post_data, function (success, data) {
                    if (success) {
                        if (($scope.referral.image.delete && !$scope.referral.image.new) || !$scope.referral_program.allow_referral_logo) {
                            LoyaltyService.DeleteReferralLogo(data.loyalty_id, function (success, referralData) {
                                if (success) {
                                    saveReferrerImage(data.loyalty_id)
                                }
                            });
                        } else if ($scope.referral.image.new) {
                            var image = $scope.referral.image.cropped || $scope.referral.image.src;
                            LoyaltyService.UploadReferralLogo(data.loyalty_id, image, function (success, referralData) {
                                if (success) {
                                    saveReferrerImage(data.loyalty_id);
                                    $scope.referral.image.new = false;
                                    $scope.referral.image.src = '';
                                    $scope.referral.image.delete = false;
                                }
                            });
                        } else {
                            saveReferrerImage(data.loyalty_id)
                        }

                        NotifyService.Success('', false);
                    }
                    block_edit.stop();
                });
            }
        };

        function saveReferrerImage(loyalty_id) {
            if (($scope.referrer.image.delete && !$scope.referrer.image.new) || !$scope.referral_program.allow_referrer_logo) {
                LoyaltyService.DeleteReferrerLogo(loyalty_id, function (success, referralData) {
                    if (success) {
                        getReferralProgram();
                    }
                });
            } else if ($scope.referrer.image.new) {
                var image = $scope.referrer.image.cropped || $scope.referrer.image.src;
                LoyaltyService.UploadReferrerLogo(loyalty_id, image, function (success, referralData) {
                    if (success) {
                        getReferralProgram();
                        $scope.referrer.image.new = false;
                        $scope.referrer.image.src = '';
                        $scope.referrer.image.delete = false;
                        $scope.referrer.image.cropped = '';
                    }
                });
            } else {
                getReferralProgram();
            }
        }

        function compareReferralLevels(level1, level2) {
            if (!level1 || !level1.level || !level2 || !level2.level) {
                return 0;
            }

            return level1.level - level2.level;
        };

        $scope.isReferralLevelValueCurrent = function (item) {
            return $scope.isReferralLevelValueEdit && (item == $scope.editingReferralLevel);
        };

        $scope.onReferralLevelValueEditClick = function (value) {
            $scope.isReferralLevelValueEdit = true;
            $scope.editingReferralLevel = value;
            $scope.backupReferralLevel = angular.copy(value);
        };

        $scope.onReferralLevelValueDeleteClick = function (value) {
            $scope.referral_program.levels.forEach(function (item) {
                if (item == value) {
                    $scope.referral_program.levels.splice($scope.referral_program.levels.indexOf(value), 1);
                }
            });

            $scope.referral_program.levels.sort(compareReferralLevels);
            var level_number = 0;
            $scope.referral_program.levels.forEach(function (item) {
                level_number += 1;
                item.level = level_number;
            });
        };

        $scope.onCancelReferralLevelValue = function () {
            $scope.isReferralLevelValueEdit = false;

            if ($scope.isReferralLevelValueAdd) {
                $scope.onReferralLevelValueDeleteClick($scope.editingReferralLevel);
            } else {
                $scope.editingReferralLevel.level = $scope.backupReferralLevel.level;
                $scope.editingReferralLevel.value = $scope.backupReferralLevel.value;
                $scope.backupReferralLevel = null;
            }

            $scope.isReferralLevelValueAdd = false;
        };

        $scope.onSaveReferralLevelValue = function (item, index) {
            if (item) {
                var existLevels = false;

                $scope.referral_program.levels.forEach(function (item) {
                    if (!(item == $scope.editingReferralLevel) && (item.level == $scope.editingReferralLevel.level)) existLevels = true;
                });

                if (existLevels) {
                    NotifyService.Warning('Same level already exists!', false);
                } else {
                    // OK, store
                    $scope.isReferralLevelValueEdit = false;
                    $scope.isReferralLevelValueAdd = false;
                    $scope.editingReferralLevel = null;
                    $scope.backupReferralLevel = null;

                    var orderBy = $filter('orderBy');
                    $scope.referral_program.levels = orderBy($scope.referral_program.levels, 'level', false);
                }
            }
        };

        $scope.onAddReferralLevelValue = function () {
            $scope.newlevel = {
                level: 1,
                value: 0,
                value_depends_type: 'none'
            };

            if ($scope.referral_program.levels) {
                $scope.newlevel.level = $scope.referral_program.levels.length + 1;
            }

            $scope.isReferralLevelValueAdd = true;
            $scope.isReferralLevelValueEdit = true;
            $scope.referral_program.levels.push($scope.newlevel);
            console.info('Store', $scope.referral_program);
            $scope.editingReferralLevel = $scope.newlevel;
            $scope.onSaveReferralLevelValue($scope.newlevel);
            $scope.openModalEditReferralLevels($scope.newlevel, false);
        };

        // *********************************************************************************************
        //  EDIT ONLINE STORE
        // *********************************************************************************************

        function getOnlineStore() {
            $scope.online_store = {
                active: 0,
                terminal_id: null,
                payment_type: 'none',
                notification_emails: [],
                notification_email: null
            };

            block_edit.start();

            getDeliveryTypes();

            LoyaltyService.LoyaltyOnlineStore($routeParams.loyalty_id, function (success, data) {
                if (success) {
                    $scope.online_store = $rootScope.LOYALTY_ONLINE_STORE[$routeParams.loyalty_id];

                    if (!$scope.online_store.active)
                        $scope.online_store.active = 0;

                    if (!$scope.online_store.payment_type)
                        $scope.online_store.payment_type = 'none';

                    if (!$scope.online_store.cart_expire_days ||
                        $scope.online_store.cart_expire_days === 0)
                        $scope.online_store.cart_expire_days = 30;

                    // if ($scope.online_store.notification_emails && $scope.online_store.notification_emails.length > 0) {
                    //   $scope.online_store.notification_email = $scope.online_store.notification_emails[0];
                    // }

                    $scope.multilang.initStrings($scope.online_store, ['public_title', 'additional_customer_info']);

                    console.info('Online Store Settings', $scope.online_store);

                    TerminalService.All(function (success, data) {
                        if (success) {
                            $scope.loyaltyTerminals = [];
                            $rootScope.TERMINALS.forEach(function (item) {
                                if ($routeParams.loyalty_id === item.loyalty_id && (item.active == 1 || item.id == $scope.online_store.terminal_id)) {
                                    $scope.loyaltyTerminals.push(item);
                                }
                            });
                            console.log('TERMINALS', $scope.loyaltyTerminals);
                        }
                        block_edit.stop();
                    });
                } else {
                    block_edit.stop();
                }
            });
        }

        $scope.removeNotificationEmail = function (index) {
            $scope.online_store.notification_emails.splice(index, 1);
        };
        $scope.addNotificationEmail = function () {
            if (!$scope.online_store.notification_emails) {
                $scope.online_store.notification_emails = [];
            }

            $scope.online_store.notification_emails.push('');

        };
        $scope.onSaveOnlineStore = function (form) {
            console.log('onSaveOnlineStore', form);

            var post_data = angular.copy($scope.online_store);

            //post_data.notification_emails = [];
            // if (post_data.notification_email) {
            //   post_data.notification_emails.push(post_data.notification_email);
            // }
            //delete post_data.notification_email;

            if (isFormValid(form)) {
                block_edit.start();
                LoyaltyService.LoyaltyOnlineStoreEdit($routeParams.loyalty_id, post_data, function (success, data) {
                    if (success) {
                        NotifyService.Success('', false);
                    }
                    block_edit.stop();
                });
            }
        };

        function getDeliveryTypes() {
            var id = $routeParams.loyalty_id;

            block_edit.start();
            LoyaltyService.DeliveryTypes(id, function (success, data) {
                if (success) {
                    $scope.delivery_types = $rootScope.DELIVERY_TYPES[id];
                    $scope.model.isDeliveryEdit = false;
                }
                block_edit.stop();
            });
        }

        /**
         * Disable/enable delivery
         */
        $scope.onDeliveryToggleClick = function (delivery) {
            if (delivery) {
                delivery.active = delivery.active == 0 ? 1 : 0;
                LoyaltyService.ChangeDeliveryType(delivery.id, delivery, function (success, data) {
                    if (success)
                        NotifyService.Success('', false);
                    else
                        delivery.active = data.active;
                });
            }
        };

        /**
         * Add delivery to loyalty
         */
        $scope.onAddDelivery = function () {

            $scope.delivery = {
                loyalty_id: $scope.loyaltyId,
                active: 1,
                price: [{'value': 0.00, 'threshold': 0}],
                delivery_address_required: 'none',
                delivery_date_required: 0,
                delivery_time_required: 0
            };

            $scope.isDeliveryPriceLevelEdit = false;
            $scope.isDeliveryPriceLevelAdd = false;
            $scope.editingDeliveryPriceLevel = null;
            $scope.backupDeliveryPriceLevel = null;

            $scope.delivery_multilang.initStrings($scope.delivery, ['public_title', 'additional_customer_info']);

            console.info('onAddDelivery delivery', $scope.delivery);

            // Go to edit mode
            $scope.model.isDeliveryEdit = true;
        };

        /**
         * Start delivery edit
         */
        $scope.onDeliveryEdit = function (delivery) {

            if (delivery) {
                $scope.delivery = angular.copy(delivery);

                $scope.isDeliveryPriceLevelEdit = false;
                $scope.isDeliveryPriceLevelAdd = false;
                $scope.editingDeliveryPriceLevel = null;
                $scope.backupDeliveryPriceLevel = null;

                $scope.delivery_multilang.initStrings($scope.delivery, ['public_title', 'additional_customer_info']);

                // Go to edit mode
                $scope.model.isDeliveryEdit = true;
            }
        };

        /**
         * End delivery edit
         */
        $scope.onDeliveryCancelEdit = function () {
            $scope.model.isDeliveryEdit = false;
        };

        /**
         * Save delivery
         */
        $scope.submitDeliveryForm = function (form) {
            console.info('submitDeliveryForm', form);

            var post_data = angular.copy($scope.delivery);
            var errors = false;

            console.info('submitDeliveryForm post_data', post_data);

            function _updateDelivery(response) {
                updateItemInList($rootScope.DELIVERY_TYPES[$routeParams.loyalty_id], response);
                $scope.model.isDeliveryEdit = false;
                NotifyService.Success('', false);
            }

            if (isFormValid(form)) {
                block_edit.start();
                if ($scope.delivery.id) {
                    LoyaltyService.ChangeDeliveryType($scope.delivery.id, post_data, function (success, response) {
                        if (success)
                            _updateDelivery(response);

                        block_edit.stop();
                    });
                } else {
                    LoyaltyService.CreateDeliveryType(post_data, function (success, response) {
                        if (success)
                            _updateDelivery(response);

                        block_edit.stop();
                    });
                }
            } else {
            }
        };

        $scope.onAddDeliveryPriceValue = function () {
            $scope.newlevel = {
                threshold: 0,
                value: 0
            };

            if ($scope.delivery) {
                $scope.isDeliveryPriceLevelAdd = true;
                $scope.isDeliveryPriceLevelEdit = true;
                $scope.delivery.price.push($scope.newlevel);
                console.info('Store', $scope.delivery);
                $scope.editingDeliveryPriceLevel = $scope.newlevel;
            }
        };

        $scope.isDeliveryPriceValueCurrent = function (item) {
            return $scope.isDeliveryPriceLevelEdit && (item == $scope.editingDeliveryPriceLevel);
        };

        $scope.deliveryPriceValueEditClick = function (value) {
            $scope.isDeliveryPriceLevelEdit = true;
            $scope.editingDeliveryPriceLevel = value;
            $scope.backupDeliveryPriceLevel = angular.copy(value);
        };

        $scope.deliveryPriceValueDeleteClick = function (value) {
            $scope.delivery.price.forEach(function (item) {
                if (item == value) {
                    $scope.delivery.price.splice($scope.delivery.price.indexOf(value), 1);
                }
            });
        };

        $scope.onSaveDeliveryPriceValue = function (item, index, form) {
            if (item && form.$valid) {
                var existThreshold = false;
                var existValue = false;

                $scope.delivery.price.forEach(function (item) {
                    if (!(item == $scope.editingDeliveryPriceLevel) &&
                        (item.threshold == $scope.editingDeliveryPriceLevel.threshold)) existThreshold = true;
                    if (!(item == $scope.editingDeliveryPriceLevel) && (item.value == $scope.editingDeliveryPriceLevel.value)) existValue = true;
                });

                if (existThreshold) {
                    NotifyService.Warning('Threshold with same value exists!', false);
                } else if (existValue) {
                    NotifyService.Warning('Price with same value exists!', false);
                } else {
                    // OK, store
                    $scope.isDeliveryPriceLevelEdit = false;
                    $scope.isDeliveryPriceLevelAdd = false;
                    $scope.editingDeliveryPriceLevel = null;
                    $scope.backupDeliveryPriceLevel = null;

                    var orderBy = $filter('orderBy');
                    $scope.delivery.price = orderBy($scope.delivery.price, 'threshold', false);
                }
            } else {
                if (form['price_level_value_' + index])
                    form['price_level_value_' + index].$dirty = true;
                if (form['price_level_threshold_' + index])
                    form['price_level_threshold_' + index].$dirty = true;
            }
        };

        $scope.onCancelDeliveryPriceValue = function () {
            $scope.isDeliveryPriceLevelEdit = false;
            if ($scope.isDeliveryPriceLevelAdd) {
                $scope.deliveryPriceValueDeleteClick($scope.editingDeliveryPriceLevel);
            } else {
                $scope.editingDeliveryPriceLevel.value = $scope.backupDeliveryPriceLevel.value;
                $scope.editingDeliveryPriceLevel.thresholds = $scope.backupDeliveryPriceLevel.thresholds;
                $scope.backupDeliveryPriceLevel = null;
            }
            $scope.isDeliveryPriceLevelAdd = false;
        };

        // *********************************************************************************************

        //  EDIT PKPASS
        // *********************************************************************************************

        function getPkpassSettings() {
            getPOSList();
            LoyaltyService.GetPkpassSettings($scope.loyaltyId, function (success, data) {
                if (success) {
                    $scope.pkpass = {
                        "background_color": data.background_color ? `${data.background_color.replace('#', '')}` : null,
                        "foreground_color": data.foreground_color ? `${data.foreground_color.replace('#', '')}` : null,
                        "label_color": data.label_color ? `${data.label_color.replace('#', '')}` : null,
                        "use_individual_settings": data.use_individual_settings
                    }

                    if (data.background_color) {
                        $scope.pkpassDefault.background_color = false;
                    }

                    if (data.foreground_color) {
                        $scope.pkpassDefault.foreground_color = false;
                    }

                    if (data.label_color) {
                        $scope.pkpassDefault.label_color = false;
                    }
                }
                block_edit.stop();
            });
        }

        $scope.onCopyLink = function () {
        }

        function getLink(type) {

            var domain = 'https://' + (appConfig.platformParams.client_site[$rootScope.LANG] || appConfig.platformParams.client_site.en);
            if (type === 'plastic') {
                return domain + '/pkpass/pos/' + $scope.POSPkpass.selectedPos.id + '/new?lang=' + $rootScope.LANG;
            }
            return domain + '/pkpass/pos/' + $scope.POSPkpass.selectedPos.id + '/uid?lang=' + $rootScope.LANG;
        }

        $scope.selectPOSForPkpass = function () {
            $scope.POSPkpass.link = getLink($scope.POSPkpass.cardType.type);
            ShortenerService.Create($scope.POSPkpass.link, function (success, response) {
                if (!success) {
                    $scope.POSPkpass.qrCodeLink = $scope.POSPkpass.link;
                    return;
                }
                $scope.POSPkpass.qrCodeLink = response.url;
            });
        }

        $scope.onSelectCardTypeForPkpass = function (model) {
            $scope.POSPkpass.link = getLink($scope.POSPkpass.cardType.type);
            ShortenerService.Create($scope.POSPkpass.link, function (success, response) {
                if (!success) {
                    $scope.POSPkpass.qrCodeLink = $scope.POSPkpass.link;
                    return;
                }
                $scope.POSPkpass.qrCodeLink = response.url;
            });
        };

        $scope.onSavePkpass = function (form) {
            console.log('onSaveOnlineStore', form);

            var data = angular.copy($scope.pkpass);

            var post_data = {
                "background_color": data.background_color ? `#${data.background_color.replace('#', '')}` : null,
                "foreground_color": data.foreground_color ? `#${data.foreground_color.replace('#', '')}` : null,
                "label_color": data.label_color ? `#${data.label_color.replace('#', '')}` : null,
                "use_individual_settings": data.use_individual_settings
            }

            if ($scope.pkpassDefault.background_color) {
                post_data.background_color = null;
            }

            if ($scope.pkpassDefault.foreground_color) {
                post_data.foreground_color = null;
            }

            if ($scope.pkpassDefault.label_color) {
                post_data.label_color = null;
            }

            if (isFormValid(form)) {
                block_edit.start();
                LoyaltyService.ChangePkpassSettings($routeParams.loyalty_id, post_data, function (success, data) {
                    if (success) {
                        $scope.pkpass = {
                            "background_color": data.background_color ? `${data.background_color.replace('#', '')}` : null,
                            "foreground_color": data.foreground_color ? `${data.foreground_color.replace('#', '')}` : null,
                            "label_color": data.label_color ? `${data.label_color.replace('#', '')}` : null,
                            "use_individual_settings": data.use_individual_settings
                        }

                        if (data.background_color) {
                            $scope.pkpassDefault.background_color = false;
                        }

                        if (data.foreground_color) {
                            $scope.pkpassDefault.foreground_color = false;
                        }

                        if (data.label_color) {
                            $scope.pkpassDefault.label_color = false;
                        }
                        NotifyService.Success('', false);
                    }
                    block_edit.stop();
                });
            }

        }

        // *********************************************************************************************

        //  EDIT DELIVERY SERVICE OR COMMISSIONS
        // *********************************************************************************************

        /*get delivery services */

        function getDeliveryServices() {

            block_edit.start();
            LoyaltyService.DeliveryServicesTypes($scope.loyaltyId, function (success, data) {
                if (success) {
                    $scope.service_list = data;
                    $scope.service_list_has_delivery = $scope.service_list.some(function (service) {
                        return service.type === 'delivery';
                    });
                }
                block_edit.stop();
            });
        }

        /* get   delivery services for editing */

        function getDeliveryServicesById(service_id, loyalty_Id) {
            block_edit.start();
            LoyaltyService.DeliveryServiceById(service_id, loyalty_Id, function (success, data) {
                if (success) {
                    $scope.delivery_service = data;
                    $scope.service_list_has_delivery = $scope.service_list.some(function (service) {
                        return service.type === 'delivery';
                    });
                    $scope.onAddDeliveryServices();
                }
                block_edit.stop();
            });
        }

        /* remove  delivery service  */

        function removeDeliveryServicesById(service) {
            block_edit.start();
            LoyaltyService.removeDeliveryServiceById(service.id, service.loyalty_id, function (success, data) {
                if (success) {
                    $scope.service_list = data;
                    $scope.service_list_has_delivery = $scope.service_list.some(function (service) {
                        return service.type === 'delivery';
                    });

                }
                block_edit.stop();
            });
        }

        /**
         * Add delivery services to loyalty
         */
        $scope.submitDeliveryServicesForm = function (form) {

            var post_data = angular.copy($scope.delivery_service);
            var errors = false;

            console.info('submitDeliveryForm post_data', post_data);

            if (isFormValid(form)) {
                block_edit.start();
                if ($scope.delivery_service.id) {
                    LoyaltyService.ChangeDeliveryService(post_data, function (success, response) {
                        if (success)
                            _updateDeliveryServices($scope.service_list, response);
                        block_edit.stop();
                    });
                } else {
                    LoyaltyService.CreateDeliveryServiceType(post_data, function (success, response) {
                        if (success)
                            _updateDeliveryServices($scope.service_list, response);

                        block_edit.stop();
                    });
                }
            } else {
            }
        };

        function _updateDeliveryServices(list, item) {
            updateItemInList(list, item);
            $scope.service_list_has_delivery = $scope.service_list.some(function (service) {
                return service.type === 'delivery';
            });
            $scope.model.isDeliveryServicesEdit = false;
            NotifyService.Success('', false);
            $scope.delivery_service = {};
        }

        $scope.onAddDeliveryServices = function () {
            if (!$scope.delivery_service.loyalty_id) {
                $scope.delivery_service = {
                    loyalty_id: $scope.loyaltyId,
                    default: 0,
                    cost: [
                        {
                            currency: $rootScope.ENV.business.currency,
                            decimal_digits: 2,
                            min_value: 0,
                            values: [
                                {
                                    threshold: 0.00,
                                    type: $scope.data.delivery_services_type[0],
                                    value: 0.00
                                }
                            ]
                        }
                    ]
                };
            }

            $scope.isDeliveryServicesCostEdit = false;
            $scope.editingDeliveryServicesCost = null;
            $scope.backupDeliveryServicesCost = null;
            $scope.isDeliveryServicesPriceLevelEdit = false;
            $scope.isDeliveryServicesPriceLevelAdd = false;
            $scope.editingDeliveryServicesPriceLevel = null;
            $scope.backupDeliveryServicesPriceLevel = null;

            $scope.delivery_service_multilang.initStrings($scope.delivery_service, ['public_title', 'public_description']);
            console.info('onAddDeliveryServices delivery', $scope.delivery_service);

            // Go to edit mode
            $scope.model.isDeliveryServicesEdit = true;
        };

        /*
    *  Delivery service cost part
    */
        $scope.isDisabledAddDeliveryServicesCost = function () {
            // currenciesList = angular.copy($scope.data.currenciesList);
            return false;
        };

        $scope.onAddDeliveryServicesCost = function () {
            $scope.newlevelServices = {
                currency: $rootScope.ENV.business.currency,
                decimal_digits: 2,
                min_value: 0,
                values: [
                    {
                        threshold: 0.00,
                        type: $scope.data.delivery_services_type[0],
                        value: 0.00
                    }
                ]
            };

            if ($scope.delivery_service) {
                // $scope.isDeliveryServicesPriceLevelAdd = true;
                // $scope.isDeliveryServicesPriceLevelEdit = true;
                $scope.isDeliveryServicesCostEdit = false;
                $scope.editingDeliveryServicesCost = null;
                $scope.backupDeliveryServicesCost = null;
                $scope.delivery_service.cost.push($scope.newlevelServices);
                console.info('$scope.delivery_service', $scope.delivery_service);
                $scope.editingDeliveryServicesPriceLevel = $scope.newlevelServices;
            }
        };
        $scope.isDeliveryServicesCostCurrent = function (cost) {
            return $scope.isDeliveryServicesCostEdit && (cost == $scope.editingDeliveryServicesCost);
        };
        $scope.deliveryServicesCostEditClick = function (cost) {
            $scope.isDeliveryServicesCostEdit = true;
            $scope.editingDeliveryServicesCost = cost;
            $scope.backupDeliveryServicesCost = angular.copy(cost);
        };
        $scope.onSaveDeliveryServicesCost = function (cost) {
            $scope.isDeliveryServicesCostEdit = false;
            $scope.editingDeliveryServicesCost = null;
            $scope.backupDeliveryServicesCost = null;
        };
        $scope.onCancelDeliveryServicesCost = function (cost) {
            $scope.isDeliveryServicesCostEdit = false;
            $scope.editingDeliveryServicesCost.min_value = $scope.backupDeliveryServicesCost.min_value;
            $scope.editingDeliveryServicesCost.decimal_digits = $scope.backupDeliveryServicesCost.decimal_digits;
            $scope.editingDeliveryServicesCost.currency = $scope.backupDeliveryServicesCost.currency;
            $scope.backupDeliveryServicesCost = null;
        };
        /*
      *  Delivery service cost values part
      */
        $scope.onAddDeliveryServicesPriceValue = function (cost) {
            var value = {
                threshold: 0,
                type: $scope.data.delivery_services_type[0],
                value: 0
            };
            cost.values.push(
                value
            );
            $scope.isDeliveryServicesPriceLevelEdit = true;
            $scope.editingDeliveryServicesPriceLevel = value;
            $scope.backupDeliveryServicesPriceLevel = angular.copy(value);
        };

        $scope.onCancelDeliveryServicesCost = function (index) {
            $scope.delivery_service.cost.splice(index, 1);
        };

        $scope.isDeliveryServicesPriceValueCurrent = function (item) {
            return $scope.isDeliveryServicesPriceLevelEdit && (item == $scope.editingDeliveryServicesPriceLevel);
        };

        $scope.deliveryServicesPriceValueEditClick = function (value) {
            $scope.isDeliveryServicesPriceLevelEdit = true;
            $scope.editingDeliveryServicesPriceLevel = value;
            $scope.backupDeliveryServicesPriceLevel = angular.copy(value);
        };
        $scope.onSaveDeliveryServicesPriceValue = function (cost, item, index, form) {
            if (item) {
                var existThreshold = false;
                var existValue = false;
                console.log('$scope.delivery_service.cost', $scope.delivery_service.cost);
                console.log('item', item);

                // TODO: check if threshold exist
                // $scope.delivery_service.cost.forEach(function (curCost) {
                //     curCost.values.forEach(function (item) {
                //         if (!(item == $scope.editingDeliveryServicesPriceLevel) &&  (item.threshold == $scope.editingDeliveryServicesPriceLevel.threshold)) existThreshold = true;
                //         if (!(item == $scope.editingDeliveryServicesPriceLevel) && (item.value == $scope.editingDeliveryServicesPriceLevel.value)) existValue = true;
                //     })
                //
                // });

                if (existThreshold) {
                    NotifyService.Warning('Threshold with same value exists!', false);
                } else if (existValue) {
                    NotifyService.Warning('Price with same value exists!', false);
                } else {
                    // OK, store
                    $scope.isDeliverySericesPriceLevelEdit = false;
                    $scope.isDeliveryServicesPriceLevelAdd = false;
                    $scope.editingDeliveryServicesPriceLevel = null;
                    $scope.backupDeliveryServicesPriceLevel = null;

                    var orderBy = $filter('orderBy');
                    // $scope.delivery_service.price = orderBy($scope.delivery.price, 'threshold', false);
                }
            }
        };
        $scope.deliveryServicesPriceValueDeleteClick = function (cost, value) {
            cost.values.forEach(function (item) {
                if (item == value) {
                    cost.values.splice(cost.values.indexOf(value), 1);
                }
            });
            console.info('$scope.delivery_service', $scope.delivery_service);
        };
        $scope.onCancelDeliveryServicesPriceValue = function () {
            $scope.isDeliveryServicesPriceLevelEdit = false;
            $scope.editingDeliveryServicesPriceLevel.value = $scope.backupDeliveryServicesPriceLevel.value;
            $scope.editingDeliveryServicesPriceLevel.threshold = $scope.backupDeliveryServicesPriceLevel.threshold;
            $scope.editingDeliveryServicesPriceLevel.type = $scope.backupDeliveryServicesPriceLevel.type;
            $scope.backupDeliveryServicesPriceLevel = null;
            $scope.isDeliveryServicesPriceLevelAdd = false;
        };
        /**
         * Start delivery service edit
         */
        $scope.onDeliveryServicesEdit = function (delivery_service) {

            if (delivery_service) {
                $scope.delivery_service = angular.copy(delivery_service);

                $scope.isDeliveryServicesPriceLevelEdit = false;
                $scope.isDeliveryServicesPriceLevelAdd = false;
                $scope.editingDeliveryServicesPriceLevel = null;
                $scope.backupDeliveryServicesPriceLevel = null;

                $scope.delivery_service_multilang.initStrings($scope.delivery_service, ['public_title', 'public_description']);

                // Go to edit mode
                $scope.model.isDeliveryServicesEdit = true;
            }
        };
        /**
         * End delivery service edit
         */
        $scope.onDeliveryServicesCancelEdit = function () {
            $scope.model.isDeliveryServicesEdit = false;
            $scope.delivery_service = {};
        };

        /* end of delivery services or commissions*/
        function getTaxes(callback) {
            var loyalty_id = $routeParams.loyalty_id;
            block_edit.start();
            LoyaltyService.GetTaxes(loyalty_id, function (success, data) {
                if (success) {
                    $scope.data.taxes = data;
                }
                block_edit.stop();
                if (callback) {
                    callback(success, data);
                }
            });
        }

        function getAdditionalCosts(callback) {
            var loyalty_id = $routeParams.loyalty_id;
            block_edit.start();
            LoyaltyService.GetAdditionalCosts(loyalty_id, function (success, data) {
                if (success) {
                    $scope.data.additional_costs = data;
                }
                block_edit.stop();
                if (callback) {
                    callback(success, data);
                }
            });
        }

        function getCardCategoriesSettings() {
            var loyalty_id = $routeParams.loyalty_id;

            $scope.card_categories_settings = {
                category_set_notification_type: 'none',
                loyalty_id: loyalty_id,
                notify_category_change_down: 0,
                notify_category_change_up: 0,
                notify_category_initial_setup: 0
            };

            block_edit.start();
            LoyaltyService.GetCardCategoriesSettings(loyalty_id, function (success, data) {
                if (success) {
                    $scope.card_categories_settings = data;
                }
                block_edit.stop();
            });

            getCardCategoriesRulesList();
        }

        function getCardCategoriesRulesList(callback) {
            var block_category_rules = blockUI.instances.get('category-rules');
            block_category_rules.start();
            LoyaltyService.GetCardCategoriesRules($routeParams.loyalty_id, function (success, data) {
                if (success) {
                    $scope.data.categoryRules = data;
                }
                block_category_rules.stop();
                if (callback) {
                    callback(data);
                }
            });
        }

        // *********************************************************************************************
        //  EDIT MESSAGE TEMPLATES
        // *********************************************************************************************

        function getMessageInfo() {
            $scope.message = {
                groups: [],
                messageVariables: [],
                templates: []
            };

            /* TODO: combine all requests */
            getMessageGroups($routeParams.loyalty_id);
            getMessageSettings($routeParams.loyalty_id);
            getMessageTemplates($routeParams.loyalty_id);

            /* TODO: remove duplicate code */
            var unbindTranslateChangeSuccess = $rootScope.$on('$translateChangeSuccess', function () {
                getMessageGroups($routeParams.loyalty_id);
                getMessageSettings($routeParams.loyalty_id);
                getMessageTemplates($routeParams.loyalty_id);
            });

            $scope.$on('$destroy', unbindTranslateChangeSuccess);
        }

        function getMessageGroups(id) {
            LoyaltyService.getMessageGroups($routeParams.loyalty_id, function (success, data) {
                if (success) {
                    $scope.message.groups = data;
                }
            });
        }

        // TODO: rename to variables
        function getMessageSettings(id) {
            LoyaltyService.getMessageSettings(id, function (success, data) {
                if (success) {
                    $scope.message.messageVariables = data;
                }
            });
        }

        function getMessageTemplates(id, oldMessageTemplateList) {
            LoyaltyService.LoyaltyMessageTemplates(id, function (success, data) {
                if (success) {

                    // use lang value in template object for translating each block
                    $scope.message.templates = initMessageTemplates(data, oldMessageTemplateList);

                }
            });
        }

        function initMessageTemplates(data, oldMessageTemplateList) {
            return data.map(function (messageTemplate) {
                messageTemplate.lang = $scope.LANG;

                if (oldMessageTemplateList && oldMessageTemplateList.length) {
                    var oldMessageTemplate = oldMessageTemplateList.find(function (oldMessageData) {
                        return oldMessageData.id === messageTemplate.id;
                    });

                    if (oldMessageTemplate && oldMessageTemplate.lang) {
                        messageTemplate.lang = oldMessageTemplate.lang;
                    }
                }

                if (!messageTemplate.template) {
                    // messageTemplate.template = messageTemplate.default_template;
                }

                if (!messageTemplate.example) {
                    messageTemplate.example = {};
                }
                if (!messageTemplate.isTest) {
                    messageTemplate.isTest = {};
                }

                return messageTemplate;
            });
        }

        function setVariableValue(field, messageTemplate, available_value, inputID) {
            if (!messageTemplate.template) {
                messageTemplate.template = {};
            }

            if (!field.$viewValue && (!messageTemplate.template || !messageTemplate.template[messageTemplate.lang])) {
                messageTemplate.template[messageTemplate.lang] = available_value;
                return;
            }

            var message = field.$viewValue;
            var inputEl = angular.element(document.querySelector('#' + inputID));

            if (inputEl.prop('selectionStart') || inputEl.prop('selectionStart') == '0') {

                // Для браузеров типа Firefox и других Webkit-ов
                var startPos = inputEl.prop('selectionStart');
                var endPos = inputEl.prop('selectionEnd');
                var scrollTop = inputEl.prop('scrollTop');
                message = message.substring(0, startPos) + available_value + message.substring(endPos, message.length);

                inputEl.focus();
                inputEl.selectionStart = startPos + available_value.length;
                inputEl.selectionEnd = startPos + available_value.length;
                inputEl.scrollTop = scrollTop;
            } else {
                message += available_value;
                inputEl.focus();
            }
            // inputEl.triggerHandler('change');
            messageTemplate.template[messageTemplate.lang] = message;
            $scope.templateTestDebounce(messageTemplate);
            field.$$setModelValue(message);
        }

        $scope.templateTestDebounce = function (messageTemplate) {
            block_edit.start();
            $scope.templateTest(messageTemplate);
        };

        $scope.templateTest = function (messageTemplate) {

            var template = messageTemplate.template[messageTemplate.lang];
            var isTest = {
                error: false,
                error_string: ''
            };

            LoyaltyService.LoyaltyMessageTemplatesTest($routeParams.loyalty_id, {
                id: messageTemplate.id,
                language: messageTemplate.lang,
                template: template
            }, function (success, data) {
                if (data.error) {
                    isTest = {
                        error: true,
                        error_string: data.error_string
                    };
                }

                messageTemplate.example[messageTemplate.lang] = data.example;
                messageTemplate.isTest[messageTemplate.lang] = isTest;

                block_edit.stop();
            });

        };

        $scope.addVariableToMessage = function (field, messageTemplate, available_value, inputID) {
            setVariableValue(field, messageTemplate, available_value, inputID);
            field.$setDirty();
        };

        $scope.isNotRequiredValues = function (availableValue, requiredValueArr) {
            return requiredValueArr.indexOf(availableValue) === -1;
        };

        $scope.showRequiredVariables = function () {
            return messageTemplate.required_values.replace('{{', '').replace('}}', '').indexOf(available_value) !== -1;
        };

        $scope.showAllowedVariables = function () {
            return messageTemplate.required_values.replace('{{', '').replace('}}', '').indexOf(available_value) === -1;
        };

        $scope.variableToAlias = function (messageTemplate, availableValues) {
            if (!availableValues) {
                availableValues = [];
            }
            if (!messageTemplate) {
                return '';
            }
            var message = messageTemplate.template[messageTemplate.lang];

            var regex = /\{\{[\d\w]+\}\}+/g;
            var messageVariables = message.match(regex);

            if (messageVariables && messageVariables.length) {
                messageVariables.forEach(function (variable) {
                    if (availableValues.indexOf(variable) !== -1) {
                        var variableSetting = $scope.message.messageVariables.find(function (messageVariable) {
                            return messageVariable.value === variable;
                        });

                        if (variableSetting) {
                            message = message.replace(variable, variableSetting.example);
                        }
                    }
                });
            }

            return message;
        };

        $scope.variableToTitle = function (availableValue) {

            var variableSetting = $scope.message.messageVariables.find(function (messageVariable) {
                return messageVariable.value === availableValue;
            });

            if (variableSetting) {
                availableValue = variableSetting.title;
            }

            return availableValue;
        };

        $scope.gotoAnchor = function (anchor) {
            $anchorScroll.yOffset = 60;
            $anchorScroll(anchor);
        };

        $scope.showErrorRequiredTtitles = function (requiredValuesArray) {
            var errorString = '';

            if (requiredValuesArray && requiredValuesArray.length) {
                requiredValuesArray.forEach(function (requiredValue, k) {
                    var grammarSymbol = ',';

                    if (k === requiredValuesArray.length - 1) {
                        grammarSymbol = '.';
                    }

                    errorString += ' "' + $scope.variableToTitle(requiredValue) + '"' + grammarSymbol;
                });
            }

            return errorString;
        };

        $scope.onChangeMessagesMultiLangs = function (form, messageTemplate, lang) {
            if (form.$valid) {
                messageTemplate.lang = lang;
            }
        };

        $scope.saveMessageTemplate = function (form, messageTemplate) {
            var dataArr = [];
            form.$setDirty();

            if (form.$valid) {
                block_edit.start();
                dataArr.push(messageTemplate);

                LoyaltyService.updateMessageTemplates($routeParams.loyalty_id, dataArr, function (success, data) {
                    if (success) {
                        $scope.message.templates = initMessageTemplates(data);
                        NotifyService.Success('', false);
                    }
                    block_edit.stop();
                });
            }
        };

        $scope.cancelMessageTemplate = function (form, messageTemplateList) {
            form.message_template.$$setModelValue('');
            form.$setPristine();
            getMessageTemplates($routeParams.loyalty_id, messageTemplateList);
        };

        // *********************************************************************************************
        //  /END EDIT MESSAGE TEMPLATES
        // *********************************************************************************************

        // *********************************************************************************************
        //  EDIT EXTERNAL FORMS RULES TEMPLATES
        // *********************************************************************************************

        function getExternalFormsRules(callback) {
            var params = {
                only_active: false
            }
            LoyaltyService.GetExternalFormsRules($routeParams.loyalty_id, params, function (success, data) {
                if (success) {
                    $scope.external_forms_rules = data;
                }
                callback();
            });
        }

        $scope.onAddExternalFormsRule = function (rule) {

            var block_change = blockUI.instances.get('change_rule'),
                start_of_the_day = new Date(),
                end_of_the_day = new Date();
            block_change.start();
            start_of_the_day.setHours(0, 0, 0, 0);
            end_of_the_day.setHours(23, 59, 59, 999);

            $uibModal.open({
                animation: true,
                keyboard: true,
                backdrop: 'static',
                size: 'lg',
                templateUrl: 'app/templates/modal.external-forms-rule.html',
                controllerAs: 'popup',
                windowTopClass: 'modal-center',
                controller: function ($uibModalInstance) {

                    var popup = this;

                    popup.rule = rule;

                    popup.getRule = function (ruleId) {
                        LoyaltyService.GetExternalFormsRuleById($routeParams.loyalty_id, ruleId, function (success, data) {
                            if (success) {
                                popup.external_forms_rule = data;
                                popup.AddNewCondition = false;
                                block_change.stop();
                            }
                        });
                    }

                    popup.scope_allowed = [
                        {id: 'all', title: 'All'},
                        {id: 'retail-customers', title: 'Retail customers'},
                        {id: 'corporate-customers', title: 'Corporate users'}
                    ];
                    popup.scope_select = popup.scope_allowed[1];
                    popup.week_days = angular.copy($scope.data.week_days);
                    popup.POSList = [];
                    getPOSList(function (success, response) {
                        popup.POSList = angular.copy($scope.model.POSList);
                    });

                    popup.goodsList = [];
                    getGoods(function (success) {
                        popup.goodsList = angular.copy($scope.model.goodsList);
                    });

                    popup.rule_period = angular.copy($scope.data.rule_period);
                    popup.expire_value_open = false;

                    popup.external_forms_rule = {
                        active: 1,
                        conditions: [],
                        expire_period: "none",
                        expire_value: 0,
                        external_form_id: null,
                        pos: [],
                        scope: popup.scope_allowed[1].id,
                        title: '',
                    };

                    if (rule) {
                        popup.getRule(rule.id);
                    } else {
                        block_change.stop();
                    }

                    popup.ExternalFormsList = [];

                    popup.rule_condition = {
                        currency: "",
                        depends_type: "check-amount",
                        goods_items: [],
                        payment_type: "all",
                        value: 0,
                    };

                    popup.dependsTypes = [
                        {id: 'check-amount', title: 'external_forms#depends_types#check-amount'},
                        {id: 'item-amount', title: 'external_forms#depends_types#item-amount'},
                        {id: 'item-quantity', title: 'external_forms#depends_types#quantity'}
                    ];

                    popup.paymentTypes = [
                        {id: 'all', title: 'external_forms#payment_types#all'},
                        {id: 'currency', title: 'external_forms#payment_types#currency'},
                        {id: 'special-account-money', title: 'external_forms#payment_types#special-account-money'},
                        {id: 'special-account-goods', title: 'external_forms#payment_types#special-account-goods'},
                        {id: 'special-account-punches', title: 'external_forms#payment_types#special-account-punches'},
                    ];

                    popup.rulePeriod = [
                        {id: 'none', title: 'external_forms#rule_period#for_all_time'},
                        {id: 'day', title: 'external_forms#rule_period#for_day'},
                        {id: 'month', title: 'external_forms#rule_period#for_months'},
                        {id: 'year', title: 'external_forms#rule_period#for_year'},
                        {id: 'current-day', title: 'external_forms#rule_period#for_current_day'},
                        // {id: 'current-week', title: 'external_forms#rule_period#for_current_week'},
                        {id: 'current-month', title: 'external_forms#rule_period#for_current_month'},
                        {id: 'current-quarter', title: 'external_forms#rule_period#for_current_quarter'},
                        {id: 'current-year', title: 'external_forms#rule_period#for_current_year'},
                    ];

                    popup.currenciesList = angular.copy($scope.data.currenciesList);

                    popup.AddNewCondition = false;

                    popup.NewConditions = [];
                    popup.NewCondition = {
                        currency: popup.currenciesList[0] || null,
                        depends_type: null,
                        goods_items: [],
                        payment_type: null,
                        value: 0
                    }

                    popup.AddCondition = function () {
                        popup.NewCondition = {
                            currency: popup.currenciesList[0] || null,
                            depends_type: null,
                            goods_items: [],
                            payment_type: null,
                            value: 0
                        }
                        popup.AddNewCondition = true;
                    }

                    popup.CancelAddCondition = function () {
                        popup.NewCondition = {
                            currency: null,
                            depends_type: null,
                            goods_items: [],
                            payment_type: null,
                            value: 0
                        }
                        popup.AddNewCondition = false;
                    }

                    popup.SaveCondition = function (conditionForm) {
                        if (conditionForm.$invalid) {
                            conditionForm.depends_type.$touched = true;
                            conditionForm.currency.$touched = true;
                            return;
                        }
                        if (popup.external_forms_rule.id) {
                            block_change.start();
                            LoyaltyService.AddExternalFormsRuleCondition($routeParams.loyalty_id, popup.external_forms_rule.id, popup.NewCondition, function (success, data) {
                                if (success) {
                                    popup.getRule(popup.external_forms_rule.id);
                                } else {
                                    NotifyService.Error(data.message, true);
                                    block_change.stop();
                                }
                            })
                        } else {
                            popup.NewConditions.push(popup.NewCondition);
                            popup.AddNewCondition = false;
                        }
                    }

                    popup.EditCondition = function (condition, $index) {
                        condition.edit = true;
                        popup.external_forms_rule.conditions[$index].edit = true;
                    }

                    popup.CancelEditCondition = function (condition, $index) {
                        condition.edit = false;
                        popup.external_forms_rule.conditions[$index].edit = false;
                    }

                    popup.SaveEditCondition = function (form, condition, $index) {

                        if (form.$invalid) {
                            form.title.$touched = true;
                            form.external_forms.$touched = true;
                            return;
                        }
                        block_change.start();
                        LoyaltyService.UpdateExternalFormsRuleConditionById($routeParams.loyalty_id, popup.external_forms_rule.id, condition.id, condition, function (success, data) {
                            if (success) {
                                popup.external_forms_rule.conditions[$index] = angular.copy(data);
                            }
                            block_change.stop();
                        })
                    }

                    popup.RemoveCondition = function (condition) {
                        block_change.start();
                        LoyaltyService.DeleteExternalFormsRuleConditionById($routeParams.loyalty_id, popup.external_forms_rule.id, condition.id, function (success, data) {
                            if (success) {
                                popup.getRule(popup.external_forms_rule.id);
                            } else {
                                block_change.stop();
                            }
                        })
                    }

                    popup.getExternalFormsList = function () {
                        var params = {
                            page: 1,
                            count: 200,
                            loyalty_id: $routeParams.loyalty_id
                        };

                        ExternalFormService.AllForms(params, function (success, response) {
                            if (success) {
                                popup.ExternalFormsList = response.data;
                            }
                        });
                    };

                    popup.saveExternalFormRule = function (form) {
                        if (form.$invalid) {
                            form.title.$touched = true;
                            form.external_forms.$touched = true;
                            return;
                        }

                        block_change.start();
                        if (popup.external_forms_rule.expire_period === 'data') {
                            delete popup.external_forms_rule.expire_period;
                        }

                        if (popup.external_forms_rule.id) {
                            LoyaltyService.UpdateExternalFormsRuleById($routeParams.loyalty_id, popup.external_forms_rule.id, popup.external_forms_rule, function (success, data) {
                                if (success) {
                                    popup.external_forms_rule = data;
                                    popup.getRule(popup.external_forms_rule.id);
                                } else {
                                    NotifyService.Error(data.message, true);
                                }
                                block_change.stop();
                            });
                            return;
                        }

                        LoyaltyService.AddExternalFormsRule($routeParams.loyalty_id, popup.external_forms_rule, function (success, data) {
                            if (success) {
                                popup.external_forms_rule = data;
                                popup.getRule(data.id);
                            }
                            block_change.stop();
                        });
                    };

                    popup.closeModal = function (exit) {
                        block_edit.start();
                        getExternalFormsRules(function () {
                            $uibModalInstance.close();
                            block_edit.stop();
                        });
                    };
                }
            });
        };

        $scope.onExternalFormToggleClick = function (rule) {
            block_edit.start();
            if (rule.active === 1) {
                rule.active = 0
            } else {
                rule.active = 1
            }
            LoyaltyService.UpdateExternalFormsRuleById($routeParams.loyalty_id, rule.id, rule, function (success, data) {
                if (success) {
                    NotifyService.Success('', false);
                }
                getExternalFormsRules(function () {
                    block_edit.stop();
                })
            });
        }

        $scope.onDeleteExternalFormsRule = function (rule) {
            block_edit.start();
            LoyaltyService.DeleteExternalFormsRuleById($routeParams.loyalty_id, rule.id, function (success, data) {
                if (success) {
                    getExternalFormsRules(function () {
                        block_edit.stop();
                    })
                } else {
                    block_edit.stop();
                }
            })
        }

        // *********************************************************************************************
        //  END EDIT EXTERNAL FORMS RULES TEMPLATES
        // *********************************************************************************************

        // *********************************************************************************************
        //  EDIT EXTERNAL ACCESS TEMPLATES
        // *********************************************************************************************

        $scope.addExternalAccess = function () {
            $uibModal.open({
                animation: true,
                keyboard: true,
                size: 'md',
                templateUrl: 'app/pages/loyalty/modals/modal.external-access.add.html',
                controllerAs: 'popup',
                controller: function ($uibModalInstance) {
                    var popup = this;
                    popup.data = {
                        title: '',
                        scope: []
                    }
                    popup.scope = [];
                    $scope.data.scope.forEach(function (el) {
                        popup.scope.push({
                            title: el.title,
                            value: el.value,
                            checked: true
                        })
                    })
                    popup.onCreateAccess = function () {
                        popup.scope.forEach(function (el) {
                            if (el.checked) {
                                popup.data.scope.push(el.value)
                            }
                        })
                        var loyaltyId = $routeParams.loyalty_id;
                        LoyaltyService.AddExternalAccess(loyaltyId, popup.data, function (success, data) {
                            if (success) {
                                NotifyService.Success('', false);
                                loadExternalAccessInfo();
                                $uibModalInstance.close();
                            }
                        })
                    }
                    popup.onCancelClick = function () {
                        $uibModalInstance.close();
                    }
                }
            })
        }

        $scope.onAccessEditClick = function (item) {
            $uibModal.open({
                animation: true,
                keyboard: true,
                size: 'md',
                templateUrl: 'app/pages/loyalty/modals/modal.external-access.edit.html',
                controllerAs: 'popup',
                controller: function ($uibModalInstance) {
                    var popup = this;
                    popup.data = {
                        title: item.title,
                        scope: []
                    }
                    popup.scope = [];

                    $scope.data.scope.forEach(function (el) {
                        var checked = item.scope.find(function (scopeItem) {
                            return scopeItem === el.value;
                        })

                        popup.scope.push({
                            title: el.title,
                            value: el.value,
                            checked: !!checked
                        })
                    })

                    popup.onCreateAccess = function () {
                        popup.data.scope = [];
                        popup.scope.forEach(function (el) {
                            if (el.checked) {
                                popup.data.scope.push(el.value)
                            }
                        })
                        var loyaltyId = $routeParams.loyalty_id;
                        LoyaltyService.UpdateExternalAccess(loyaltyId, item.id, popup.data, function (success, data) {
                            if (success) {
                                NotifyService.Success('', false);
                                loadExternalAccessInfo();
                                $uibModalInstance.close();
                            }
                        })
                    }
                    popup.onCancelClick = function () {
                        $uibModalInstance.close();
                    }
                }
            })
        }

        $scope.onAccessDeleteClick = function (item) {
            var loyaltyId = $routeParams.loyalty_id;
            LoyaltyService.RemoveExternalAccess(
                loyaltyId,
                item.id,
                function (success, data) {
                    if (success) {
                        NotifyService.Success('', false);
                        loadExternalAccessInfo();
                    }
                }
            )

        }

        $scope.popupAPIKEY = function (api_key) {
            $uibModal.open({
                animation: true,
                keyboard: true,
                templateUrl: 'app/pages/loyalty/modals/modal.show-api-key.html',
                controllerAs: 'popup',
                controller: function ($uibModalInstance) {
                    var popup = this;
                    popup.api_key = api_key;

                    popup.onAPIKEYCopy = function () {
                        popup.APIKEYCopied = true;
                        $timeout(function () {
                            popup.APIKEYCopied = false;
                        }, 3000);
                    };

                    popup.onCancelClick = function (exit) {
                        $uibModalInstance.close();
                    };
                }
            });
        }

        function loadExternalAccessInfo() {
            block_external_access.start();
            var loyaltyId = $routeParams.loyalty_id;
            LoyaltyService.GetExternalAccessList(loyaltyId, function (success, data) {
                if (success) {
                    $scope.external_access = data;
                }
                block_external_access.stop();
            });
        }

        function loadExternalAccessScope() {
            LoyaltyService.GetExternalAccessScope(function (success, data) {
                if (success) {
                    $scope.data.scope = data;
                }
            })
        }

        // *********************************************************************************************
        //  END EDIT EXTERNAL ACCESS TEMPLATES
        // *********************************************************************************************

        $scope.onExportSettings = function (download) {
            var loyaltyId = $routeParams.loyalty_id;
            block_export_import.start();
            ExportLoyaltyService.Export(loyaltyId, $scope.to_export_sections, function (success, data) {
                block_export_import.stop();
                $scope.export_loyalty_data = data;
                if (download) {
                    saveJSONToFile(`export_loyalty_${loyaltyId}`, data)
                } else {
                    $scope.operationResult = $uibModal.open({
                        animation: true,
                        keyboard: true,
                        size: 'lg',
                        templateUrl: 'app/templates/modal.raw.html',
                        controllerAs: 'popup',
                        controller: function ($uibModalInstance) {

                            var popup = this;

                            popup.model = {
                                raw: data
                            };

                            popup.onCancelClick = function () {
                                $uibModalInstance.close();
                            };

                        }
                    });
                }

            })
        }

        function saveJSONToFile(file_name, data) {
            var json = angular.toJson(data, true),
                blob = new Blob([json], {
                    type: 'application/json;charset=utf-8;'
                }),
                dl = document.createElement('a');

            dl.setAttribute('download', file_name + '_date_' + moment().unix() + '.json');
            dl.setAttribute('href', window.URL.createObjectURL(blob));
            dl.click();
        }

        $scope.onImportFileSelect = function () {
            $scope.import.sections = null;
            $scope.import.file = null;
            $scope.import.preview = null;
            var file = angular.element(document.getElementById('import-file'));
            file.val(null);
        };

        $scope.fileChanged = function (event) {
            var files = event.srcElement.files;
            var file = files[0];
            $scope.import.file = file;
            var reader = new FileReader();

            reader.onloadend = function (evt) {
                if (evt.target.readyState === FileReader.DONE) {
                    $scope.$apply(function () {
                        $scope.import.preview = JSON.parse(evt.target.result)
                        ExportLoyaltyService.parseImportSections($scope.import.preview, function (success, data) {
                            $scope.import.sections = data;
                        })
                    });
                }
            };

            reader.readAsText(file);
        };

        $scope.onPreviewImportSettings = function () {
            $scope.operationResult = $uibModal.open({
                animation: true,
                keyboard: true,
                size: 'lg',
                templateUrl: 'app/templates/modal.raw.html',
                controllerAs: 'popup',
                controller: function ($uibModalInstance) {
                    var popup = this;

                    popup.model = {
                        raw: $scope.import.preview
                    };

                    popup.onCancelClick = function () {
                        $uibModalInstance.close();
                    };
                }
            });
        }

        $scope.selectAllToExport = function () {
            if ($scope.import.selectedAllToExport) {
                $scope.to_export_sections.map(function (section) {
                    return section.included = true;
                })
            } else {
                $scope.to_export_sections.map(function (section) {
                    return section.included = false;
                })
            }
        }

        $scope.selectToExport = function () {
            $scope.import.selectedAllToExport = !$scope.to_export_sections.some(someFunc);

            function someFunc(value) {
                return !value.included;
            }
        }

        $scope.disabledExportImport = function (sections) {
            return sections.some(someFunc);

            function someFunc(value) {
                return value.included;
            }
        }

        $scope.selectAllToImport = function () {
            if ($scope.import.selectedAll) {
                $scope.import.sections.map(function (section) {
                    return section.included = true;
                })
            } else {
                $scope.import.sections.map(function (section) {
                    return section.included = false;
                })
            }
        }

        $scope.selectToImport = function () {
            $scope.import.selectedAll = !$scope.import.sections.some(someFunc);

            function someFunc(value) {
                return !value.included;
            }
        }

        $scope.onImportSettings = function () {
            block_export_import.start();
            var loyaltyId = $routeParams.loyalty_id;
            ExportLoyaltyService.import(loyaltyId, $scope.import.sections, $scope.import.preview, function (success, errors) {
                block_export_import.stop();

                if (errors.length === 0) {
                    return;
                }

                $scope.operationResult = $uibModal.open({
                    animation: true,
                    keyboard: true,
                    size: 'lg',
                    templateUrl: 'app/pages/loyalty/modals/modal.export_settings-result.html',
                    controllerAs: 'popup',
                    controller: function ($uibModalInstance) {
                        var popup = this;
                        popup.errors = errors;
                        popup.onCancelClick = function () {
                            $uibModalInstance.close();
                        };
                    }
                });

            })
        }

    }

})();
